// This file is auto-generated by @hey-api/openapi-ts

import { createClient, createConfig, type Options, urlSearchParamsBodySerializer } from '@hey-api/client-fetch';
import type { ApiTokenAuthCreateData, ApiTokenAuthCreateError, ApiTokenAuthCreateResponse, ActiveAiAvatarVoicePresetListError, ActiveAiAvatarVoicePresetListResponse, ActiveAiAvatarVoicePresetRetrieveData, ActiveAiAvatarVoicePresetRetrieveError, ActiveAiAvatarVoicePresetRetrieveResponse, AdminMediaFoldersListData, AdminMediaFoldersListError, AdminMediaFoldersListResponse, AdminVideoDataRetrieveData, AdminVideoDataRetrieveError, AdminVideoDataRetrieveResponse, AdminVideoFixMediaCreateData, AdminVideoFixMediaCreateError, AdminVideoFixMediaCreateResponse, AdminVideoRenderTriageRetrieveData, AdminVideoRenderTriageRetrieveError, AdminVideoRenderTriageRetrieveResponse, AdminVideoRenderTriageCreateData, AdminVideoRenderTriageCreateError, AdminVideoRenderTriageCreateResponse, AdminWorkspacesListData, AdminWorkspacesListError, AdminWorkspacesListResponse, AiAvatarListError, AiAvatarListResponse, AiAvatarRetrieveData, AiAvatarRetrieveError, AiAvatarRetrieveResponse, AiMediaModelsListError, AiMediaModelsListResponse, AiVoiceCloneCreateData, AiVoiceCloneCreateError, AiVoiceCloneCreateResponse, AiVoiceClonePartialUpdateData, AiVoiceClonePartialUpdateError, AiVoiceClonePartialUpdateResponse, AiVoiceCloneDestroyError, AiVoiceCloneDestroyResponse, AiVoiceCloneLimitRetrieveError, AiVoiceCloneLimitRetrieveResponse, AiVoiceCloneCreate2Data, AiVoiceCloneCreate2Error, AiVoiceCloneCreate2Response, AiVoiceClonePartialUpdate2Data, AiVoiceClonePartialUpdate2Error, AiVoiceClonePartialUpdate2Response, AiVoiceCloneDestroy2Data, AiVoiceCloneDestroy2Error, AiVoiceCloneDestroy2Response, AiVoiceFilterListData, AiVoiceFilterListError, AiVoiceFilterListResponse, AiVoiceFilterRetrieveData, AiVoiceFilterRetrieveError, AiVoiceFilterRetrieveResponse, AiVoiceV2ListData, AiVoiceV2ListError, AiVoiceV2ListResponse, AiVoiceV2RetrieveData, AiVoiceV2RetrieveError, AiVoiceV2RetrieveResponse, AiVoiceV2RetrieveBySlugQueryData, AiVoiceV2RetrieveBySlugQueryError, AiVoiceV2RetrieveBySlugQueryResponse, AiVoiceV2DefaultVoiceRetrieveError, AiVoiceV2DefaultVoiceRetrieveResponse, AiVoiceV2TastingMenuListError, AiVoiceV2TastingMenuListResponse, AiVoiceV2ToggleFavouriteCreateData, AiVoiceV2ToggleFavouriteCreateError, AiVoiceV2ToggleFavouriteCreateResponse, AnimationExitSurveyCreateData, AnimationExitSurveyCreateError, AnimationExitSurveyCreateResponse, AnnouncementsListData, AnnouncementsListError, AnnouncementsListResponse, AnnouncementsMarkClickedCreateData, AnnouncementsMarkClickedCreateError, AnnouncementsMarkClickedCreateResponse, AnnouncementsMarkViewedCreateData, AnnouncementsMarkViewedCreateError, AnnouncementsMarkViewedCreateResponse, AnnouncementsPublicListError, AnnouncementsPublicListResponse, AnnouncementsUnreadCountRetrieveError, AnnouncementsUnreadCountRetrieveResponse, ArticleImagesListData, ArticleImagesListError, ArticleImagesListResponse, ArticleImagesDestroyData, ArticleImagesDestroyError, ArticleImagesDestroyResponse, ArticleImagesDeleteAllDestroyData, ArticleImagesDeleteAllDestroyError, ArticleImagesDeleteAllDestroyResponse, ArticleRetrieveData, ArticleRetrieveError, ArticleRetrieveResponse, ArticleUpdateData, ArticleUpdateError, ArticleUpdateResponse, ArticlePartialUpdateData, ArticlePartialUpdateError, ArticlePartialUpdateResponse, ArticleReplaceUrlUpdateData, ArticleReplaceUrlUpdateError, ArticleReplaceUrlUpdateResponse, ArticleSentencesRetrieveData, ArticleSentencesRetrieveError, ArticleSentencesRetrieveResponse, AssetAudioEnhancementRetrieveData, AssetAudioEnhancementRetrieveError, AssetAudioEnhancementRetrieveResponse, AssetDeletionGcsDestroyData, AssetDeletionGcsDestroyError, AssetDeletionGcsDestroyResponse, AssetSaveCreateData, AssetSaveCreateError, AssetSaveCreateResponse, AssetTranscriptRetrieveData, AssetTranscriptRetrieveError, AssetTranscriptRetrieveResponse, AssetValidationUpdateData, AssetValidationUpdateError, AssetValidationUpdateResponse, AsyncOperationResultRetrieveData, AsyncOperationResultRetrieveError, AsyncOperationResultRetrieveResponse, AsyncOperationsListData, AsyncOperationsListError, AsyncOperationsListResponse, AudioRetrieveData, AudioRetrieveError, AudioRetrieveResponse, AudioDestroyData, AudioDestroyError, AudioDestroyResponse, AudioassetRetrieveData, AudioassetRetrieveError, AudioassetRetrieveResponse, AuditLogListData, AuditLogListError, AuditLogListResponse, AuditLogExportCsvCreateError, AuditLogExportCsvCreateResponse, BackgroundAssetsDestroyData, BackgroundAssetsDestroyError, BackgroundAssetsDestroyResponse, BackgroundRemovalCreateData, BackgroundRemovalCreateError, BackgroundRemovalCreateResponse, BatchTextToVoiceoverCreateData, BatchTextToVoiceoverCreateError, BatchTextToVoiceoverCreateResponse, BillingChargesListError, BillingChargesListResponse, BillingPreferencesRetrieveError, BillingPreferencesRetrieveResponse, BillingPreferencesUpdateData, BillingPreferencesUpdateError, BillingPreferencesUpdateResponse, BillingSubscribersListError, BillingSubscribersListResponse, BillingSubscribersCreateData, BillingSubscribersCreateError, BillingSubscribersCreateResponse, BillingSubscribersDestroyData, BillingSubscribersDestroyError, BillingSubscribersDestroyResponse, BlueprintAutoPickCreateData, BlueprintAutoPickCreateError, BlueprintAutoPickCreateResponse, BlueprintRecommendationsCreateData, BlueprintRecommendationsCreateError, BlueprintRecommendationsCreateResponse, BlueprintsListData, BlueprintsListError, BlueprintsListResponse, BlueprintsRetrieveData, BlueprintsRetrieveError, BlueprintsRetrieveResponse, BlueprintsTemplateStyleVideoDataRetrieveData, BlueprintsTemplateStyleVideoDataRetrieveError, BlueprintsTemplateStyleVideoDataRetrieveResponse, BlueprintsVideoDataRetrieveData, BlueprintsVideoDataRetrieveError, BlueprintsVideoDataRetrieveResponse, BrandKitsListError, BrandKitsListResponse, BrandKitsCreateData, BrandKitsCreateError, BrandKitsCreateResponse, BrandKitsRetrieveData, BrandKitsRetrieveError, BrandKitsRetrieveResponse, BrandKitsUpdateData, BrandKitsUpdateError, BrandKitsUpdateResponse, BrandKitsDestroyData, BrandKitsDestroyError, BrandKitsDestroyResponse, BrandKitsCountRetrieveError, BrandKitsCountRetrieveResponse, BulkAssetSourceCreateData, BulkAssetSourceCreateError, BulkAssetSourceCreateResponse, BulkMediaAssetsListData, BulkMediaAssetsListError, BulkMediaAssetsListResponse, BulkTextSegmentationCreateData, BulkTextSegmentationCreateError, BulkTextSegmentationCreateResponse, ChangePasswordCreateData, ChangePasswordCreateError, ChangePasswordCreateResponse, ChangeWorkspaceUpdateData, ChangeWorkspaceUpdateError, ChangeWorkspaceUpdateResponse, ChartStylesListError, ChartStylesListResponse, ClicklogsclickCreateData, ClicklogsclickCreateError, ClicklogsclickCreateResponse, ClicklogsqueryCreateData, ClicklogsqueryCreateError, ClicklogsqueryCreateResponse, ClicklogsrecommendationCreateData, ClicklogsrecommendationCreateError, ClicklogsrecommendationCreateResponse, ClipPlannerCreateData, ClipPlannerCreateError, ClipPlannerCreateResponse, CodeoBrandsListError, CodeoBrandsListResponse, CodeoBrandsCreateData, CodeoBrandsCreateError, CodeoBrandsCreateResponse, CodeoBrandsUpdateData, CodeoBrandsUpdateError, CodeoBrandsUpdateResponse, CodeoBrandsPartialUpdateData, CodeoBrandsPartialUpdateError, CodeoBrandsPartialUpdateResponse, CodeoBrandsDestroyData, CodeoBrandsDestroyError, CodeoBrandsDestroyResponse, ColorFilterListData, ColorFilterListError, ColorFilterListResponse, ListConversationsData, ListConversationsError, ListConversationsResponse, SaveConversationData, SaveConversationError, SaveConversationResponse2, GetConversationData, GetConversationError, GetConversationResponse, RecordConversationInteractionData, RecordConversationInteractionError, RecordConversationInteractionResponse, GetLatestConversationForVideoData, GetLatestConversationForVideoError, GetLatestConversationForVideoResponse, CopyMediaAssetsCreateData, CopyMediaAssetsCreateError, CopyMediaAssetsCreateResponse, CustomBlueprintsListData, CustomBlueprintsListError, CustomBlueprintsListResponse, CustomBlueprintsCreateData, CustomBlueprintsCreateError, CustomBlueprintsCreateResponse, CustomBlueprintsRetrieveData, CustomBlueprintsRetrieveError, CustomBlueprintsRetrieveResponse, CustomBlueprintsPartialUpdateData, CustomBlueprintsPartialUpdateError, CustomBlueprintsPartialUpdateResponse, CustomBlueprintsDestroyData, CustomBlueprintsDestroyError, CustomBlueprintsDestroyResponse, CustomBlueprintsDuplicateCreateData, CustomBlueprintsDuplicateCreateError, CustomBlueprintsDuplicateCreateResponse, CustomBlueprintsCreateFromSimilarCreateData, CustomBlueprintsCreateFromSimilarCreateError, CustomBlueprintsCreateFromSimilarCreateResponse, DamSearchCreateData, DamSearchCreateError, DamSearchCreateResponse, DatasetMetadataRetrieveData, DatasetMetadataRetrieveError, DatasetMetadataRetrieveResponse, DatasetMetadataUpdateData, DatasetMetadataUpdateError, DatasetMetadataUpdateResponse, DatasetMetadataPartialUpdateData, DatasetMetadataPartialUpdateError, DatasetMetadataPartialUpdateResponse, DocumentExtractCreateData, DocumentExtractCreateError, DocumentExtractCreateResponse, DocumentResetUpdateData, DocumentResetUpdateError, DocumentResetUpdateResponse, DocumentsCreateData, DocumentsCreateError, DocumentsCreateResponse, DocumentsImagesListData, DocumentsImagesListError, DocumentsImagesListResponse, DocumentsImagesDestroyData, DocumentsImagesDestroyError, DocumentsImagesDestroyResponse, DocumentsImagesDeleteAllDestroyData, DocumentsImagesDeleteAllDestroyError, DocumentsImagesDeleteAllDestroyResponse, DocumentsUpdateData, DocumentsUpdateError, DocumentsUpdateResponse, DocumentsPartialUpdateData, DocumentsPartialUpdateError, DocumentsPartialUpdateResponse, EditVoiceoverUpdateData, EditVoiceoverUpdateError, EditVoiceoverUpdateResponse, EmailExistsCreateData, EmailExistsCreateError, EmailExistsCreateResponse, EmailVerificationStatusRetrieveData, EmailVerificationStatusRetrieveError, EmailVerificationStatusRetrieveResponse, FaceDetectionCreateData, FaceDetectionCreateError, FaceDetectionCreateResponse, FavoritesListMarkedFavoritesListData, FavoritesListMarkedFavoritesListError, FavoritesListMarkedFavoritesListResponse, FavoritesMarkFavoriteCreateData, FavoritesMarkFavoriteCreateError, FavoritesMarkFavoriteCreateResponse, FavoritesUnmarkFavoriteDestroyError, FavoritesUnmarkFavoriteDestroyResponse, FeedbackBetaCreateData, FeedbackBetaCreateError, FeedbackBetaCreateResponse, FetchMediaCandidatesCreateData, FetchMediaCandidatesCreateError, FetchMediaCandidatesCreateResponse, FlagEnrollRetrieveData, FlagEnrollRetrieveError, FlagEnrollRetrieveResponse, FlagWithdrawRetrieveData, FlagWithdrawRetrieveError, FlagWithdrawRetrieveResponse, FlagListAllListError, FlagListAllListResponse, FontAssetsListError, FontAssetsListResponse, FontAssetsDestroyData, FontAssetsDestroyError, FontAssetsDestroyResponse, FreepikLicenseCreateData, FreepikLicenseCreateError, FreepikLicenseCreateResponse, GenerateChartConfigCreateData, GenerateChartConfigCreateError, GenerateChartConfigCreateResponse, GenerateMediaCandidatesCreateData, GenerateMediaCandidatesCreateError, GenerateMediaCandidatesCreateResponse, GenerateScriptCreateData, GenerateScriptCreateError, GenerateScriptCreateResponse, GenerateScriptFromPromptCreateData, GenerateScriptFromPromptCreateError, GenerateScriptFromPromptCreateResponse, GenerateVideoRecommendationCreateData, GenerateVideoRecommendationCreateError, GenerateVideoRecommendationCreateResponse, GenerateVideosForVideoPlansCreateData, GenerateVideosForVideoPlansCreateError, GenerateVideosForVideoPlansCreateResponse, GenxAnalyticsRetrieveError, GenxAnalyticsRetrieveResponse, GenxEvalsEvalRunsListData, GenxEvalsEvalRunsListError, GenxEvalsEvalRunsListResponse, GenxEvalsEvalRunsCreateData, GenxEvalsEvalRunsCreateError, GenxEvalsEvalRunsCreateResponse, GenxEvalsEvalRunsRetrieveData, GenxEvalsEvalRunsRetrieveError, GenxEvalsEvalRunsRetrieveResponse, GenxEvalsEvalRunsPartialUpdateData, GenxEvalsEvalRunsPartialUpdateError, GenxEvalsEvalRunsPartialUpdateResponse, GenxEvalsEvalRunsDestroyData, GenxEvalsEvalRunsDestroyError, GenxEvalsEvalRunsDestroyResponse, GenxEvalsEvalRunsScriptsCreateData, GenxEvalsEvalRunsScriptsCreateError, GenxEvalsEvalRunsScriptsCreateResponse, GenxEvalsEvalRunsScriptsIngredientsPartialUpdateData, GenxEvalsEvalRunsScriptsIngredientsPartialUpdateError, GenxEvalsEvalRunsScriptsIngredientsPartialUpdateResponse, GenxEvalsEvalSetsListError, GenxEvalsEvalSetsListResponse, GenxEvalsEvalSetsCreateData, GenxEvalsEvalSetsCreateError, GenxEvalsEvalSetsCreateResponse, GenxEvalsEvalSetsRetrieveData, GenxEvalsEvalSetsRetrieveError, GenxEvalsEvalSetsRetrieveResponse, GenxEvalsEvalSetsUpdateData, GenxEvalsEvalSetsUpdateError, GenxEvalsEvalSetsUpdateResponse, GenxEvalsEvalSetsPartialUpdateData, GenxEvalsEvalSetsPartialUpdateError, GenxEvalsEvalSetsPartialUpdateResponse, GenxEvalsEvalSetsDestroyData, GenxEvalsEvalSetsDestroyError, GenxEvalsEvalSetsDestroyResponse, GenxEvalsEvalSetsScriptsCreateData, GenxEvalsEvalSetsScriptsCreateError, GenxEvalsEvalSetsScriptsCreateResponse, GenxEvalsGradesCreateData, GenxEvalsGradesCreateError, GenxEvalsGradesCreateResponse, GenxEvalsGradesPartialUpdateData, GenxEvalsGradesPartialUpdateError, GenxEvalsGradesPartialUpdateResponse, GenxEvalsGradesDestroyData, GenxEvalsGradesDestroyError, GenxEvalsGradesDestroyResponse, GenxEvalsPresetsListError, GenxEvalsPresetsListResponse, GenxEvalsPresetsScoreHistoryListData, GenxEvalsPresetsScoreHistoryListError, GenxEvalsPresetsScoreHistoryListResponse, GenxEvalsScriptsPartialUpdateData, GenxEvalsScriptsPartialUpdateError, GenxEvalsScriptsPartialUpdateResponse, GenxEvalsScriptsDestroyData, GenxEvalsScriptsDestroyError, GenxEvalsScriptsDestroyResponse, GenxEvalsShotsPartialUpdateData, GenxEvalsShotsPartialUpdateError, GenxEvalsShotsPartialUpdateResponse, GenxPresetBuilderScenariosListError, GenxPresetBuilderScenariosListResponse, GenxPresetBuilderScenariosCreateData, GenxPresetBuilderScenariosCreateError, GenxPresetBuilderScenariosCreateResponse, GenxPresetBuilderScenariosUpdateData, GenxPresetBuilderScenariosUpdateError, GenxPresetBuilderScenariosUpdateResponse, GenxPresetBuilderScenariosPartialUpdateData, GenxPresetBuilderScenariosPartialUpdateError, GenxPresetBuilderScenariosPartialUpdateResponse, GenxPresetBuilderScenariosDestroyData, GenxPresetBuilderScenariosDestroyError, GenxPresetBuilderScenariosDestroyResponse, GenxPreviousIngredientsListData, GenxPreviousIngredientsListError, GenxPreviousIngredientsListResponse, ListGenxSessionsData, ListGenxSessionsError, ListGenxSessionsResponse, CreateGenxSessionData, CreateGenxSessionError, CreateGenxSessionResponse, GetGenxSessionData, GetGenxSessionError, GetGenxSessionResponse, AppendGenxEventsData, AppendGenxEventsError, AppendGenxEventsResponse, LinkGenxSessionVideoData, LinkGenxSessionVideoError, LinkGenxSessionVideoResponse, GenxStylePresetsListData, GenxStylePresetsListError, GenxStylePresetsListResponse, GenxStylePresetsCreateCreateData, GenxStylePresetsCreateCreateError, GenxStylePresetsCreateCreateResponse, GetLanguageInfoForTextCreateData, GetLanguageInfoForTextCreateError, GetLanguageInfoForTextCreateResponse, HtmlDesignSkillPreviewsListError, HtmlDesignSkillPreviewsListResponse, HtmlDesignSkillPreviewsCreateData, HtmlDesignSkillPreviewsCreateError, HtmlDesignSkillPreviewsCreateResponse, ImageGenerationCreateData, ImageGenerationCreateError, ImageGenerationCreateResponse, InternalRenderTriageReportCreateData, InternalRenderTriageReportCreateError, InternalRenderTriageReportCreateResponse, InternalRenderTriageReportsRecentRetrieveError, InternalRenderTriageReportsRecentRetrieveResponse, IsAuthenticatedRetrieveError, IsAuthenticatedRetrieveResponse, LogMediaAgentResultsCreateData, LogMediaAgentResultsCreateError, LogMediaAgentResultsCreateResponse, LongestSupportedDurationTargetsCreateData, LongestSupportedDurationTargetsCreateError, LongestSupportedDurationTargetsCreateResponse, MediaAssetTextRepresentationRetrieveData, MediaAssetTextRepresentationRetrieveError, MediaAssetTextRepresentationRetrieveResponse, MediaConceptPreviewCreateData, MediaConceptPreviewCreateError, MediaConceptPreviewCreateResponse, MediaFoldersListError, MediaFoldersListResponse, MediaFoldersCreateData, MediaFoldersCreateError, MediaFoldersCreateResponse, MediaFoldersRetrieveData, MediaFoldersRetrieveError, MediaFoldersRetrieveResponse, MediaFoldersPartialUpdateData, MediaFoldersPartialUpdateError, MediaFoldersPartialUpdateResponse, MediaFoldersDestroyData, MediaFoldersDestroyError, MediaFoldersDestroyResponse, MediaSearchCreateData, MediaSearchCreateError, MediaSearchCreateResponse, MergeTeamsCreateData, MergeTeamsCreateError, MergeTeamsCreateResponse, MixyCreateData, MixyCreateError, MixyCreateResponse, MusicRecommendationCreateData, MusicRecommendationCreateError, MusicRecommendationCreateResponse, NameSuggestionCreateData, NameSuggestionCreateError, NameSuggestionCreateResponse, NotificationsListError, NotificationsListResponse, NotificationsMarkAsReadPartialUpdateData, NotificationsMarkAsReadPartialUpdateError, NotificationsMarkAsReadPartialUpdateResponse, NotificationsMarkAllAsReadPartialUpdateError, NotificationsMarkAllAsReadPartialUpdateResponse, NotificationsNumUnreadRetrieveError, NotificationsNumUnreadRetrieveResponse, PasswordForgotCreateData, PasswordForgotCreateError, PasswordForgotCreateResponse, PasswordResetCreateData, PasswordResetCreateError, PasswordResetCreateResponse, PrefetchMediaCandidatesCreateData, PrefetchMediaCandidatesCreateError, PrefetchMediaCandidatesCreateResponse, PremiumMediaCreditCheckCreateData, PremiumMediaCreditCheckCreateError, PremiumMediaCreditCheckCreateResponse, PricingCancellationFeedbackCreateData, PricingCancellationFeedbackCreateError, PricingCancellationFeedbackCreateResponse, PricingCreditCardDetailsRetrieveError, PricingCreditCardDetailsRetrieveResponse, PricingCurrentPlanNameRetrieveData, PricingCurrentPlanNameRetrieveError, PricingCurrentPlanNameRetrieveResponse, PricingPaymentMethodCheckoutUpdateData, PricingPaymentMethodCheckoutUpdateError, PricingPaymentMethodCheckoutUpdateResponse, PricingPaymentMethodStatusRetrieveError, PricingPaymentMethodStatusRetrieveResponse, PricingPlansRetrieveData, PricingPlansRetrieveError, PricingPlansRetrieveResponse, PricingPremiumMediaRetrieveError, PricingPremiumMediaRetrieveResponse, PricingRenewSubscriptionCreateError, PricingRenewSubscriptionCreateResponse, PricingSubscriptionRetrieveError, PricingSubscriptionRetrieveResponse, PricingSubscriptionCreateData, PricingSubscriptionCreateError, PricingSubscriptionCreateResponse, PricingSubscriptionPartialUpdateData, PricingSubscriptionPartialUpdateError, PricingSubscriptionPartialUpdateResponse, PricingSubscriptionPauseCreateData, PricingSubscriptionPauseCreateError, PricingSubscriptionPauseCreateResponse, PricingSubscriptionPreviewRetrieveData, PricingSubscriptionPreviewRetrieveError, PricingSubscriptionPreviewRetrieveResponse, PricingSubscriptionResumeCreateError, PricingSubscriptionResumeCreateResponse, ProjectsListError, ProjectsListResponse, ProjectsCreateData, ProjectsCreateError, ProjectsCreateResponse, ProjectsRetrieveData, ProjectsRetrieveError, ProjectsRetrieveResponse, ProjectsPartialUpdateData, ProjectsPartialUpdateError, ProjectsPartialUpdateResponse, ProjectsDestroyData, ProjectsDestroyError, ProjectsDestroyResponse, ProjectsBulkUpdateMembersCreateData, ProjectsBulkUpdateMembersCreateError, ProjectsBulkUpdateMembersCreateResponse, PronunciationListError, PronunciationListResponse, PronunciationUpsertData, PronunciationUpsertError, PronunciationUpsertResponse, PronunciationDestroyData, PronunciationDestroyError, PronunciationDestroyResponse, PublicVideoRetrieveData, PublicVideoRetrieveError, PublicVideoRetrieveResponse, QueueEstimatedRenderDurationRetrieveError, QueueEstimatedRenderDurationRetrieveResponse, QueueVideoRenderDetailsRetrieveData, QueueVideoRenderDetailsRetrieveError, QueueVideoRenderDetailsRetrieveResponse, RecentlyUsedTemplatesListError, RecentlyUsedTemplatesListResponse, RegenerateTranscriptForAssetCreateData, RegenerateTranscriptForAssetCreateError, RegenerateTranscriptForAssetCreateResponse, RegenerateMfaBackupKeysCreateError, RegenerateMfaBackupKeysCreateResponse, RenderDiagnosticsCreateError, RenderDiagnosticsCreateResponse, RenderDiagnosticsBaselineBundleRetrieveError, RenderDiagnosticsBaselineBundleRetrieveResponse, ResolveCommentsCreateData, ResolveCommentsCreateError, ResolveCommentsCreateResponse, SaveVideoDataSnapshotCreateData, SaveVideoDataSnapshotCreateError, SaveVideoDataSnapshotCreateResponse, SceneAttributesListData, SceneAttributesListError, SceneAttributesListResponse, SceneDesignsListData, SceneDesignsListError, SceneDesignsListResponse, SceneDesignsCreateData, SceneDesignsCreateError, SceneDesignsCreateResponse, SceneDesignsRetrieveData, SceneDesignsRetrieveError, SceneDesignsRetrieveResponse, SceneDesignsUpdateData, SceneDesignsUpdateError, SceneDesignsUpdateResponse, SceneDesignsPartialUpdateData, SceneDesignsPartialUpdateError, SceneDesignsPartialUpdateResponse, SceneDesignsDestroyData, SceneDesignsDestroyError, SceneDesignsDestroyResponse, SceneDesignsBulkUpdateUpdateData, SceneDesignsBulkUpdateUpdateError, SceneDesignsBulkUpdateUpdateResponse, SceneDesignsIdsPerTemplateListError, SceneDesignsIdsPerTemplateListResponse, SceneDesignsTemplateAnnotationsRetrieveData, SceneDesignsTemplateAnnotationsRetrieveError, SceneDesignsTemplateAnnotationsRetrieveResponse, ScriptOptionsCreateData, ScriptOptionsCreateError, ScriptOptionsCreateResponse, SendEmailVerificationCreateData, SendEmailVerificationCreateError, SendEmailVerificationCreateResponse, SendMfaRecoveryCodeCreateData, SendMfaRecoveryCodeCreateError, SendMfaRecoveryCodeCreateResponse, ShareGptFeedbackCreateData, ShareGptFeedbackCreateError, ShareGptFeedbackCreateResponse, SimpleTextCorrectionCreateData, SimpleTextCorrectionCreateError, SimpleTextCorrectionCreateResponse, SketchContextInfoRetrieveError, SketchContextInfoRetrieveResponse, SketchResearchCreateData, SketchResearchCreateError, SketchResearchCreateResponse, SketchUrlFetchCreateData, SketchUrlFetchCreateError, SketchUrlFetchCreateResponse, SketchValidateVideoPlansCreateData, SketchValidateVideoPlansCreateError, SketchValidateVideoPlansCreateResponse, SketchWebImageSearchCreateData, SketchWebImageSearchCreateError, SketchWebImageSearchCreateResponse, SoundEffectStylesListError, SoundEffectStylesListResponse, SoundEffectsListData, SoundEffectsListError, SoundEffectsListResponse, SsoIdpConfigCreateData, SsoIdpConfigCreateError, SsoIdpConfigCreateResponse, SsoIdpConfigRetrieveData, SsoIdpConfigRetrieveError, SsoIdpConfigRetrieveResponse, SsoIdpConfigUpdateData, SsoIdpConfigUpdateError, SsoIdpConfigUpdateResponse, SsoIdpConfigPartialUpdateData, SsoIdpConfigPartialUpdateError, SsoIdpConfigPartialUpdateResponse, SsoIdpConfigDestroyData, SsoIdpConfigDestroyError, SsoIdpConfigDestroyResponse, SsoVerficationCreateData, SsoVerficationCreateError, SsoVerficationCreateResponse, SubmitFeedbackCreateData, SubmitFeedbackCreateError, SubmitFeedbackCreateResponse, SuggestedMediaCreateData, SuggestedMediaCreateError, SuggestedMediaCreateResponse, SupportedLanguagesListError, SupportedLanguagesListResponse, TaskResultRetrieveData, TaskResultRetrieveError, TaskResultRetrieveResponse, TaskResultDestroyData, TaskResultDestroyError, TaskResultDestroyResponse, TaskResultsListData, TaskResultsListError, TaskResultsListResponse, TeamInvitationsListError, TeamInvitationsListResponse, TeamInvitationsCreateData, TeamInvitationsCreateError, TeamInvitationsCreateResponse, TeamInvitationsRetrieveData, TeamInvitationsRetrieveError, TeamInvitationsRetrieveResponse, TeamInvitationsDestroyData, TeamInvitationsDestroyError, TeamInvitationsDestroyResponse, TeamInvitationsResendCreateData, TeamInvitationsResendCreateError, TeamInvitationsResendCreateResponse, TeamMembersListError, TeamMembersListResponse, TeamMembersUpdateData, TeamMembersUpdateError, TeamMembersUpdateResponse, TeamMembersPartialUpdateData, TeamMembersPartialUpdateError, TeamMembersPartialUpdateResponse, TeamMembersDestroyData, TeamMembersDestroyError, TeamMembersDestroyResponse, TeamMembersDeleteUserAccountDestroyData, TeamMembersDeleteUserAccountDestroyError, TeamMembersDeleteUserAccountDestroyResponse, TeamMembersTwoFactorAuthenticationRetrieveError, TeamMembersTwoFactorAuthenticationRetrieveResponse, TeamMembersTwoFactorAuthenticationCreateData, TeamMembersTwoFactorAuthenticationCreateError, TeamMembersTwoFactorAuthenticationCreateResponse, TeamSettingsRetrieveError, TeamSettingsRetrieveResponse, TeamSettingsPartialUpdateData, TeamSettingsPartialUpdateError, TeamSettingsPartialUpdateResponse, TemplateCategoriesListError, TemplateCategoriesListResponse, TemplateInfoListData, TemplateInfoListError, TemplateInfoListResponse, TemplatesListError, TemplatesListResponse, TemplatesCreateData, TemplatesCreateError, TemplatesCreateResponse, TemplatesRetrieveData, TemplatesRetrieveError, TemplatesRetrieveResponse, TemplatesUpdateData, TemplatesUpdateError, TemplatesUpdateResponse, TemplatesPartialUpdateData, TemplatesPartialUpdateError, TemplatesPartialUpdateResponse, TemplatesDestroyData, TemplatesDestroyError, TemplatesDestroyResponse, TemplatesEnableForTemplatesCreateData, TemplatesEnableForTemplatesCreateError, TemplatesEnableForTemplatesCreateResponse, TemplatesDisplayGroupsListData, TemplatesDisplayGroupsListError, TemplatesDisplayGroupsListResponse, TemplatesDisplayGroupsCreateData, TemplatesDisplayGroupsCreateError, TemplatesDisplayGroupsCreateResponse, TemplatesDisplayGroupsRetrieveData, TemplatesDisplayGroupsRetrieveError, TemplatesDisplayGroupsRetrieveResponse, TemplatesDisplayGroupsPartialUpdateData, TemplatesDisplayGroupsPartialUpdateError, TemplatesDisplayGroupsPartialUpdateResponse, TemplatesDisplayGroupsOrderPartialUpdateData, TemplatesDisplayGroupsOrderPartialUpdateError, TemplatesDisplayGroupsOrderPartialUpdateResponse, TemplatesWaveformCapableRetrieveError, TemplatesWaveformCapableRetrieveResponse, TextToVoiceoverAssetCreateData, TextToVoiceoverAssetCreateError, TextToVoiceoverAssetCreateResponse, TextTranslateCreateData, TextTranslateCreateError, TextTranslateCreateResponse, TokensCostCreateData, TokensCostCreateError, TokensCostCreateResponse, TopUploadsTagsRetrieveData, TopUploadsTagsRetrieveError, TopUploadsTagsRetrieveResponse, TranscribeUrlCreateData, TranscribeUrlCreateError, TranscribeUrlCreateResponse, TranscriptClipCreateData, TranscriptClipCreateError, TranscriptClipCreateResponse, TranscriptionTokenCreateError, TranscriptionTokenCreateResponse, TransitionedAssetErrorCreateData, TransitionedAssetErrorCreateError, TransitionedAssetErrorCreateResponse, TranslateVideoBackendCreateData, TranslateVideoBackendCreateError, TranslateVideoBackendCreateResponse, TransmogVideoCreateData, TransmogVideoCreateError, TransmogVideoCreateResponse, TrustCenterPrivateDocumentsRetrieveData, TrustCenterPrivateDocumentsRetrieveError, TrustCenterPrivateDocumentsRetrieveResponse, UploadDiagnosticsCreateError, UploadDiagnosticsCreateResponse, UploadUrlsCreateData, UploadUrlsCreateError, UploadUrlsCreateResponse, UploadsMetadataUpdateUpdateData, UploadsMetadataUpdateUpdateError, UploadsMetadataUpdateUpdateResponse, UsageLimitsRetrieveData, UsageLimitsRetrieveError, UsageLimitsRetrieveResponse, UsedTemplatesRetrieveError, UsedTemplatesRetrieveResponse, UserRetrieveError, UserRetrieveResponse, UserExtraDataCreateData, UserExtraDataCreateError, UserExtraDataCreateResponse, UserExtraDataClearCreateData, UserExtraDataClearCreateError, UserExtraDataClearCreateResponse, UserHasValidProjectInWorkspaceRetrieveError, UserHasValidProjectInWorkspaceRetrieveResponse, UserNotificationsRetrieveData, UserNotificationsRetrieveError, UserNotificationsRetrieveResponse, UserNotificationsPartialUpdateData, UserNotificationsPartialUpdateError, UserNotificationsPartialUpdateResponse, V1ApiKeysListError, V1ApiKeysListResponse, V1ApiKeysCreateData, V1ApiKeysCreateError, V1ApiKeysCreateResponse, V1ApiKeysDestroyData, V1ApiKeysDestroyError, V1ApiKeysDestroyResponse, V1VideoCreationBlueprintsListData, V1VideoCreationBlueprintsListError, V1VideoCreationBlueprintsListResponse, V1VideoCreationBrandKitsListData, V1VideoCreationBrandKitsListError, V1VideoCreationBrandKitsListResponse, V1VideoCreationRecipesListData, V1VideoCreationRecipesListError, V1VideoCreationRecipesListResponse, V1VideoCreationRequestsListData, V1VideoCreationRequestsListError, V1VideoCreationRequestsListResponse, V1VideoCreationRequestsCreateData, V1VideoCreationRequestsCreateError, V1VideoCreationRequestsCreateResponse, V1VideoCreationRequestsRetrieveData, V1VideoCreationRequestsRetrieveError, V1VideoCreationRequestsRetrieveResponse, V1VideoCreationResolveCreateData, V1VideoCreationResolveCreateError, V1VideoCreationResolveCreateResponse, V1VideoCreationTemplatesListData, V1VideoCreationTemplatesListError, V1VideoCreationTemplatesListResponse, V1VideoCreationVoicesListData, V1VideoCreationVoicesListError, V1VideoCreationVoicesListResponse, V1VideoCreationWebhookEndpointsListData, V1VideoCreationWebhookEndpointsListError, V1VideoCreationWebhookEndpointsListResponse, V1VideoCreationWebhookEndpointsCreateData, V1VideoCreationWebhookEndpointsCreateError, V1VideoCreationWebhookEndpointsCreateResponse, V1VideoCreationWebhookEndpointsDestroyData, V1VideoCreationWebhookEndpointsDestroyError, V1VideoCreationWebhookEndpointsDestroyResponse, V1VideoCreationWebhookEndpointsRotateSecretCreateData, V1VideoCreationWebhookEndpointsRotateSecretCreateError, V1VideoCreationWebhookEndpointsRotateSecretCreateResponse, V1VideoCreationWorkspacesListData, V1VideoCreationWorkspacesListError, V1VideoCreationWorkspacesListResponse, ValidateDatasetVideoRetrieveData, ValidateDatasetVideoRetrieveError, ValidateDatasetVideoRetrieveResponse, VideoListData, VideoListError, VideoListResponse, VideoCreateData, VideoCreateError, VideoCreateResponse, VideoApprovalStatusRetrieveData, VideoApprovalStatusRetrieveError, VideoApprovalStatusRetrieveResponse, VideoApprovalStatusUpdateData, VideoApprovalStatusUpdateError, VideoApprovalStatusUpdateResponse, VideoApprovalStatusPartialUpdateData, VideoApprovalStatusPartialUpdateError, VideoApprovalStatusPartialUpdateResponse, VideoCommentListData, VideoCommentListError, VideoCommentListResponse, VideoCommentCreateData, VideoCommentCreateError, VideoCommentCreateResponse, VideoCommentDestroyData, VideoCommentDestroyError, VideoCommentDestroyResponse, VideoCreationRunOutcomeCreateData, VideoCreationRunOutcomeCreateError, VideoCreationRunOutcomeCreateResponse, VideoGenerationCreateData, VideoGenerationCreateError, VideoGenerationCreateResponse, VideoPosterValidationUpdateData, VideoPosterValidationUpdateError, VideoPosterValidationUpdateResponse, VideoRetrieveData, VideoRetrieveError, VideoRetrieveResponse, VideoUpdateData, VideoUpdateError, VideoUpdateResponse, VideoPartialUpdateData, VideoPartialUpdateError, VideoPartialUpdateResponse, VideoGroundhogAnalysisCreateData, VideoGroundhogAnalysisCreateError, VideoGroundhogAnalysisCreateResponse, VideoShareDownloadRetrieveData, VideoShareDownloadRetrieveError, VideoShareDownloadRetrieveResponse, VideoShareDownloadCreateData, VideoShareDownloadCreateError, VideoShareDownloadCreateResponse, VideoTranslateV2CreateData, VideoTranslateV2CreateError, VideoTranslateV2CreateResponse, VideoTranslatedTextListData, VideoTranslatedTextListError, VideoTranslatedTextListResponse, VideosRestoreCreateData, VideosRestoreCreateError, VideosRestoreCreateResponse, VideosVersionsRetrieveData, VideosVersionsRetrieveError, VideosVersionsRetrieveResponse, VideosVersionDataRetrieveData, VideosVersionDataRetrieveError, VideosVersionDataRetrieveResponse, VideosArchiveMultipleVideosUpdateData, VideosArchiveMultipleVideosUpdateError, VideosArchiveMultipleVideosUpdateResponse, VideosBulkPublishCreateData, VideosBulkPublishCreateError, VideosBulkPublishCreateResponse, VideosCreateFromBlueprintCreateData, VideosCreateFromBlueprintCreateError, VideosCreateFromBlueprintCreateResponse, VideosDuplicateVideosCreateData, VideosDuplicateVideosCreateError, VideosDuplicateVideosCreateResponse, VideosMoveVideosPartialUpdateData, VideosMoveVideosPartialUpdateError, VideosMoveVideosPartialUpdateResponse, VideosSceneSequencesListData, VideosSceneSequencesListError, VideosSceneSequencesListResponse, WorkspaceListError, WorkspaceListResponse, WorkspaceCreateData, WorkspaceCreateError, WorkspaceCreateResponse, WorkspaceVideoTagsRetrieveError, WorkspaceVideoTagsRetrieveResponse, WorkspaceRetrieveData, WorkspaceRetrieveError, WorkspaceRetrieveResponse, WorkspacePartialUpdateData, WorkspacePartialUpdateError, WorkspacePartialUpdateResponse, WorkspaceDestroyData, WorkspaceDestroyError, WorkspaceDestroyResponse, WorkspaceAddMembersCreateData, WorkspaceAddMembersCreateError, WorkspaceAddMembersCreateResponse, WorkspaceAnalyticsRetrieveData, WorkspaceAnalyticsRetrieveError, WorkspaceAnalyticsRetrieveResponse, WorkspaceRemoveMemberDestroyData, WorkspaceRemoveMemberDestroyError, WorkspaceRemoveMemberDestroyResponse, YoutubeChannelsListError, YoutubeChannelsListResponse, YoutubeChannelsCreateData, YoutubeChannelsCreateError, YoutubeChannelsCreateResponse, YoutubeChannelsDestroyData, YoutubeChannelsDestroyError, YoutubeChannelsDestroyResponse, AttachmentDocumentRetrieveData, AttachmentDocumentRetrieveError, AttachmentDocumentRetrieveResponse, AttachmentMediaRetrieveData, AttachmentMediaRetrieveError, AttachmentMediaRetrieveResponse, AuthInvitationRetrieveData, AuthInvitationRetrieveError, AuthInvitationRetrieveResponse, RenderVideoRenderDataRetrieveData, RenderVideoRenderDataRetrieveError, RenderVideoRenderDataRetrieveResponse } from './types.gen';

export const client = createClient(createConfig());

export class ApiService {
    public static apiTokenAuthCreate<ThrowOnError extends boolean = true>(options: Options<ApiTokenAuthCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<ApiTokenAuthCreateResponse, ApiTokenAuthCreateError, ThrowOnError>({
            ...options,
            ...urlSearchParamsBodySerializer,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                ...options?.headers
            },
            url: '/api-token-auth/'
        });
    }
    
    public static activeAiAvatarVoicePresetList<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<ActiveAiAvatarVoicePresetListResponse, ActiveAiAvatarVoicePresetListError, ThrowOnError>({
            ...options,
            url: '/api/active-ai-avatar-voice-preset/'
        });
    }
    
    public static activeAiAvatarVoicePresetRetrieve<ThrowOnError extends boolean = true>(options: Options<ActiveAiAvatarVoicePresetRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<ActiveAiAvatarVoicePresetRetrieveResponse, ActiveAiAvatarVoicePresetRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/active-ai-avatar-voice-preset/{id}/'
        });
    }
    
    public static adminMediaFoldersList<ThrowOnError extends boolean = true>(options: Options<AdminMediaFoldersListData, ThrowOnError>) {
        return (options?.client ?? client).get<AdminMediaFoldersListResponse, AdminMediaFoldersListError, ThrowOnError>({
            ...options,
            url: '/api/admin/media-folders/{workspace_id}/'
        });
    }
    
    /**
     * Staff-only endpoint to fetch video data without workspace ownership checks.
     * Used by the rendering dashboard to download video JSON for any video.
     */
    public static adminVideoDataRetrieve<ThrowOnError extends boolean = true>(options: Options<AdminVideoDataRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<AdminVideoDataRetrieveResponse, AdminVideoDataRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/admin/video/{video_id}/data/'
        });
    }
    
    /**
     * Staff-only. POST queues the fix_media_renders repair for one video (replacing missing or
     * removed media and re-licensing expired premium media), then requeues it for render.
     */
    public static adminVideoFixMediaCreate<ThrowOnError extends boolean = true>(options: Options<AdminVideoFixMediaCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<AdminVideoFixMediaCreateResponse, AdminVideoFixMediaCreateError, ThrowOnError>({
            ...options,
            url: '/api/admin/video/{video_id}/fix-media/'
        });
    }
    
    /**
     * Staff-only. POST triggers a Claude triage run for a video's latest render; a finished
     * analysis is kept, but a failed or stale-in-flight run can be retried. GET returns all
     * triage reports for the video's renders.
     */
    public static adminVideoRenderTriageRetrieve<ThrowOnError extends boolean = true>(options: Options<AdminVideoRenderTriageRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<AdminVideoRenderTriageRetrieveResponse, AdminVideoRenderTriageRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/admin/video/{video_id}/render-triage/'
        });
    }
    
    /**
     * Staff-only. POST triggers a Claude triage run for a video's latest render; a finished
     * analysis is kept, but a failed or stale-in-flight run can be retried. GET returns all
     * triage reports for the video's renders.
     */
    public static adminVideoRenderTriageCreate<ThrowOnError extends boolean = true>(options: Options<AdminVideoRenderTriageCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<AdminVideoRenderTriageCreateResponse, AdminVideoRenderTriageCreateError, ThrowOnError>({
            ...options,
            url: '/api/admin/video/{video_id}/render-triage/'
        });
    }
    
    public static adminWorkspacesList<ThrowOnError extends boolean = true>(options: Options<AdminWorkspacesListData, ThrowOnError>) {
        return (options?.client ?? client).get<AdminWorkspacesListResponse, AdminWorkspacesListError, ThrowOnError>({
            ...options,
            url: '/api/admin/workspaces/{team_id}/'
        });
    }
    
    /**
     * A simple ViewSet for viewing available ai_avatars
     */
    public static aiAvatarList<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<AiAvatarListResponse, AiAvatarListError, ThrowOnError>({
            ...options,
            url: '/api/ai-avatar/'
        });
    }
    
    /**
     * A simple ViewSet for viewing available ai_avatars
     */
    public static aiAvatarRetrieve<ThrowOnError extends boolean = true>(options: Options<AiAvatarRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<AiAvatarRetrieveResponse, AiAvatarRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/ai-avatar/{id}/'
        });
    }
    
    public static aiMediaModelsList<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<AiMediaModelsListResponse, AiMediaModelsListError, ThrowOnError>({
            ...options,
            url: '/api/ai-media-models/'
        });
    }
    
    public static aiVoiceCloneCreate<ThrowOnError extends boolean = true>(options: Options<AiVoiceCloneCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<AiVoiceCloneCreateResponse, AiVoiceCloneCreateError, ThrowOnError>({
            ...options,
            url: '/api/ai-voice-clone/'
        });
    }
    
    public static aiVoiceClonePartialUpdate<ThrowOnError extends boolean = true>(options?: Options<AiVoiceClonePartialUpdateData, ThrowOnError>) {
        return (options?.client ?? client).patch<AiVoiceClonePartialUpdateResponse, AiVoiceClonePartialUpdateError, ThrowOnError>({
            ...options,
            url: '/api/ai-voice-clone/'
        });
    }
    
    public static aiVoiceCloneDestroy<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).delete<AiVoiceCloneDestroyResponse, AiVoiceCloneDestroyError, ThrowOnError>({
            ...options,
            url: '/api/ai-voice-clone/'
        });
    }
    
    public static aiVoiceCloneLimitRetrieve<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<AiVoiceCloneLimitRetrieveResponse, AiVoiceCloneLimitRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/ai-voice-clone-limit/'
        });
    }
    
    public static aiVoiceCloneCreate2<ThrowOnError extends boolean = true>(options: Options<AiVoiceCloneCreate2Data, ThrowOnError>) {
        return (options?.client ?? client).post<AiVoiceCloneCreate2Response, AiVoiceCloneCreate2Error, ThrowOnError>({
            ...options,
            url: '/api/ai-voice-clone/{slug}/'
        });
    }
    
    public static aiVoiceClonePartialUpdate2<ThrowOnError extends boolean = true>(options: Options<AiVoiceClonePartialUpdate2Data, ThrowOnError>) {
        return (options?.client ?? client).patch<AiVoiceClonePartialUpdate2Response, AiVoiceClonePartialUpdate2Error, ThrowOnError>({
            ...options,
            url: '/api/ai-voice-clone/{slug}/'
        });
    }
    
    public static aiVoiceCloneDestroy2<ThrowOnError extends boolean = true>(options: Options<AiVoiceCloneDestroy2Data, ThrowOnError>) {
        return (options?.client ?? client).delete<AiVoiceCloneDestroy2Response, AiVoiceCloneDestroy2Error, ThrowOnError>({
            ...options,
            url: '/api/ai-voice-clone/{slug}/'
        });
    }
    
    /**
     * A simple ViewSet for listing AI voice filter values.
     * Each filter type (accent, tone, style, language, age, gender, quality) can be
     * passed as a boolean query parameter. Only filters matching types set to true
     * are returned. If no filter params are provided, all filters are returned.
     */
    public static aiVoiceFilterList<ThrowOnError extends boolean = true>(options?: Options<AiVoiceFilterListData, ThrowOnError>) {
        return (options?.client ?? client).get<AiVoiceFilterListResponse, AiVoiceFilterListError, ThrowOnError>({
            ...options,
            url: '/api/ai-voice-filter/'
        });
    }
    
    /**
     * A simple ViewSet for listing AI voice filter values.
     * Each filter type (accent, tone, style, language, age, gender, quality) can be
     * passed as a boolean query parameter. Only filters matching types set to true
     * are returned. If no filter params are provided, all filters are returned.
     */
    public static aiVoiceFilterRetrieve<ThrowOnError extends boolean = true>(options: Options<AiVoiceFilterRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<AiVoiceFilterRetrieveResponse, AiVoiceFilterRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/ai-voice-filter/{id}/'
        });
    }
    
    /**
     * ViewSet for viewing available ai_voices with pagination, search, and filtering.
     */
    public static aiVoiceV2List<ThrowOnError extends boolean = true>(options?: Options<AiVoiceV2ListData, ThrowOnError>) {
        return (options?.client ?? client).get<AiVoiceV2ListResponse, AiVoiceV2ListError, ThrowOnError>({
            ...options,
            url: '/api/ai-voice-v2/'
        });
    }
    
    /**
     * ViewSet for viewing available ai_voices with pagination, search, and filtering.
     */
    public static aiVoiceV2Retrieve<ThrowOnError extends boolean = true>(options: Options<AiVoiceV2RetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<AiVoiceV2RetrieveResponse, AiVoiceV2RetrieveError, ThrowOnError>({
            ...options,
            url: '/api/ai-voice-v2/{id}/'
        });
    }
    
    /**
     * ViewSet for viewing available ai_voices with pagination, search, and filtering.
     */
    public static aiVoiceV2RetrieveBySlugQuery<ThrowOnError extends boolean = true>(options: Options<AiVoiceV2RetrieveBySlugQueryData, ThrowOnError>) {
        return (options?.client ?? client).get<AiVoiceV2RetrieveBySlugQueryResponse, AiVoiceV2RetrieveBySlugQueryError, ThrowOnError>({
            ...options,
            url: '/api/ai-voice-v2/by-slug/'
        });
    }
    
    /**
     * Returns the single best default voice for the current user.
     *
     * Unlike the list endpoint, this excludes premium voices that the user's
     * plan doesn't grant access to (include_inaccessible_paid_plans=False),
     * so free-tier users will never receive a paid voice as their default.
     * Deprecated and disabled voices are also excluded (disabled voices are
     * already filtered by get_voices_for_team).
     *
     * Ordering priority: team-private voices first, then free voices (is_paid
     * ascending), then alphabetical. Only the first result is returned.
     */
    public static aiVoiceV2DefaultVoiceRetrieve<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<AiVoiceV2DefaultVoiceRetrieveResponse, AiVoiceV2DefaultVoiceRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/ai-voice-v2/default-voice/'
        });
    }
    
    /**
     * Returns a curated tasting menu of voices for Sketch to use: all brand voices, all free public voices, and the top 20 premium voices ranked the same way the voice search does — high-quality voices first, in trending order.
     */
    public static aiVoiceV2TastingMenuList<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<AiVoiceV2TastingMenuListResponse, AiVoiceV2TastingMenuListError, ThrowOnError>({
            ...options,
            url: '/api/ai-voice-v2/tasting-menu/'
        });
    }
    
    /**
     * ViewSet for viewing available ai_voices with pagination, search, and filtering.
     */
    public static aiVoiceV2ToggleFavouriteCreate<ThrowOnError extends boolean = true>(options: Options<AiVoiceV2ToggleFavouriteCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<AiVoiceV2ToggleFavouriteCreateResponse, AiVoiceV2ToggleFavouriteCreateError, ThrowOnError>({
            ...options,
            url: '/api/ai-voice-v2/toggle-favourite/'
        });
    }
    
    public static animationExitSurveyCreate<ThrowOnError extends boolean = true>(options?: Options<AnimationExitSurveyCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<AnimationExitSurveyCreateResponse, AnimationExitSurveyCreateError, ThrowOnError>({
            ...options,
            url: '/api/animation-exit-survey/'
        });
    }
    
    /**
     * Get active announcements for the current user.
     * Query params:
     * - url: Current page URL for targeting
     * - unread_only: Only return unread announcements
     */
    public static announcementsList<ThrowOnError extends boolean = true>(options?: Options<AnnouncementsListData, ThrowOnError>) {
        return (options?.client ?? client).get<AnnouncementsListResponse, AnnouncementsListError, ThrowOnError>({
            ...options,
            url: '/api/announcements/'
        });
    }
    
    /**
     * Mark that the user clicked the CTA on an announcement.
     */
    public static announcementsMarkClickedCreate<ThrowOnError extends boolean = true>(options: Options<AnnouncementsMarkClickedCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<AnnouncementsMarkClickedCreateResponse, AnnouncementsMarkClickedCreateError, ThrowOnError>({
            ...options,
            url: '/api/announcements/mark-clicked/'
        });
    }
    
    /**
     * Mark an announcement as viewed by the current user.
     */
    public static announcementsMarkViewedCreate<ThrowOnError extends boolean = true>(options: Options<AnnouncementsMarkViewedCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<AnnouncementsMarkViewedCreateResponse, AnnouncementsMarkViewedCreateError, ThrowOnError>({
            ...options,
            url: '/api/announcements/mark-viewed/'
        });
    }
    
    /**
     * Get all published announcements for the public changelog page.
     */
    public static announcementsPublicList<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<AnnouncementsPublicListResponse, AnnouncementsPublicListError, ThrowOnError>({
            ...options,
            url: '/api/announcements/public/'
        });
    }
    
    /**
     * Get count of unread announcements for the notification badge.
     */
    public static announcementsUnreadCountRetrieve<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<AnnouncementsUnreadCountRetrieveResponse, AnnouncementsUnreadCountRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/announcements/unread-count/'
        });
    }
    
    public static articleImagesList<ThrowOnError extends boolean = true>(options: Options<ArticleImagesListData, ThrowOnError>) {
        return (options?.client ?? client).get<ArticleImagesListResponse, ArticleImagesListError, ThrowOnError>({
            ...options,
            url: '/api/article/{article_pk}/images/'
        });
    }
    
    public static articleImagesDestroy<ThrowOnError extends boolean = true>(options: Options<ArticleImagesDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<ArticleImagesDestroyResponse, ArticleImagesDestroyError, ThrowOnError>({
            ...options,
            url: '/api/article/{article_pk}/images/{id}/'
        });
    }
    
    public static articleImagesDeleteAllDestroy<ThrowOnError extends boolean = true>(options: Options<ArticleImagesDeleteAllDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<ArticleImagesDeleteAllDestroyResponse, ArticleImagesDeleteAllDestroyError, ThrowOnError>({
            ...options,
            url: '/api/article/{article_pk}/images/delete_all/'
        });
    }
    
    public static articleRetrieve<ThrowOnError extends boolean = true>(options: Options<ArticleRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<ArticleRetrieveResponse, ArticleRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/article/{id}/'
        });
    }
    
    public static articleUpdate<ThrowOnError extends boolean = true>(options: Options<ArticleUpdateData, ThrowOnError>) {
        return (options?.client ?? client).put<ArticleUpdateResponse, ArticleUpdateError, ThrowOnError>({
            ...options,
            url: '/api/article/{id}/'
        });
    }
    
    public static articlePartialUpdate<ThrowOnError extends boolean = true>(options: Options<ArticlePartialUpdateData, ThrowOnError>) {
        return (options?.client ?? client).patch<ArticlePartialUpdateResponse, ArticlePartialUpdateError, ThrowOnError>({
            ...options,
            url: '/api/article/{id}/'
        });
    }
    
    public static articleReplaceUrlUpdate<ThrowOnError extends boolean = true>(options: Options<ArticleReplaceUrlUpdateData, ThrowOnError>) {
        return (options?.client ?? client).put<ArticleReplaceUrlUpdateResponse, ArticleReplaceUrlUpdateError, ThrowOnError>({
            ...options,
            url: '/api/article/{id}/replace_url/'
        });
    }
    
    public static articleSentencesRetrieve<ThrowOnError extends boolean = true>(options: Options<ArticleSentencesRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<ArticleSentencesRetrieveResponse, ArticleSentencesRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/article/{id}/sentences/'
        });
    }
    
    /**
     * Attempts to retrieve the asset with the specified asset_type, asset_source, and asset_source_id
     * If the asset is found, we return the serialized asset data
     * Else, we retrieve the user uploaded asset with matching source_id, get the asset_uuid, and lookup AsyncOperation
     * table for a pending audio enhancement job.
     * If an async audio enhancement job exists, we return the async_operation_uuid to the frontend for polling.
     * Else, we create an audio enhancement job and return the newly created async_operation_uuid to the frontend for polling.
     *
     * If the original asset is not found, we return a generic error.
     */
    public static assetAudioEnhancementRetrieve<ThrowOnError extends boolean = true>(options: Options<AssetAudioEnhancementRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<AssetAudioEnhancementRetrieveResponse, AssetAudioEnhancementRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/asset-audio-enhancement/'
        });
    }
    
    /**
     * Triggers the task to delete an asset (defined by its urls) from GCS
     * Params:
     * - urls: the urls to delete from GCS
     */
    public static assetDeletionGcsDestroy<ThrowOnError extends boolean = true>(options: Options<AssetDeletionGcsDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<AssetDeletionGcsDestroyResponse, AssetDeletionGcsDestroyError, ThrowOnError>({
            ...options,
            url: '/api/asset-deletion-gcs/'
        });
    }
    
    /**
     * Triggers the task to validate and save an asset
     */
    public static assetSaveCreate<ThrowOnError extends boolean = true>(options: Options<AssetSaveCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<AssetSaveCreateResponse, AssetSaveCreateError, ThrowOnError>({
            ...options,
            url: '/api/asset-save/'
        });
    }
    
    public static assetTranscriptRetrieve<ThrowOnError extends boolean = true>(options: Options<AssetTranscriptRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<AssetTranscriptRetrieveResponse, AssetTranscriptRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/asset-transcript/{asset_id}/'
        });
    }
    
    /**
     * Triggers the task to validate an asset, along with asset metadata.
     * Params:
     *
     * - bucket: the name of the bucket used
     * - file_name: the filename to validate inside of the bucket
     * - user_file_name: the original filename of the asset
     * - metadata: associated metadata to validate (attribution, license,
     * and other stuff saved in the models and common to all assets)
     * - add_to_user_library: "true" or "false", whether this upload should
     * be searchable by the user in the future (should be false
     * for branding assets)
     * - only_images: "true" of "false", whether we should only accept
     * images as valid files
     * - only_audio: "true" of "false", whether we should only accept
     * audio as valid files
     */
    public static assetValidationUpdate<ThrowOnError extends boolean = true>(options: Options<AssetValidationUpdateData, ThrowOnError>) {
        return (options?.client ?? client).put<AssetValidationUpdateResponse, AssetValidationUpdateError, ThrowOnError>({
            ...options,
            url: '/api/asset-validation/'
        });
    }
    
    /**
     * Get the result of the async operation. Instead of getting the
     * result from the task, this endpoint will look at the AsyncOperation model
     */
    public static asyncOperationResultRetrieve<ThrowOnError extends boolean = true>(options: Options<AsyncOperationResultRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<AsyncOperationResultRetrieveResponse, AsyncOperationResultRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/async-operation-result/{async_operation_uuid}/'
        });
    }
    
    public static asyncOperationsList<ThrowOnError extends boolean = true>(options?: Options<AsyncOperationsListData, ThrowOnError>) {
        return (options?.client ?? client).get<AsyncOperationsListResponse, AsyncOperationsListError, ThrowOnError>({
            ...options,
            url: '/api/async-operations/'
        });
    }
    
    /**
     * Return a list of assets that we can use as the background track to videos.
     * Params:
     *
     * - q: the search term
     * - page: the page number requested
     * - count: the number of results per page
     * - source: if we should search uploads or the audio library (uploads or cc)
     */
    public static audioRetrieve<ThrowOnError extends boolean = true>(options: Options<AudioRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<AudioRetrieveResponse, AudioRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/audio/'
        });
    }
    
    /**
     * Archives an uploaded audio asset
     * - id: the id of the audio asset in our DB
     */
    public static audioDestroy<ThrowOnError extends boolean = true>(options: Options<AudioDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<AudioDestroyResponse, AudioDestroyError, ThrowOnError>({
            ...options,
            url: '/api/audio/'
        });
    }
    
    public static audioassetRetrieve<ThrowOnError extends boolean = true>(options: Options<AudioassetRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<AudioassetRetrieveResponse, AudioassetRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/audioasset/{uuid}/'
        });
    }
    
    public static auditLogList<ThrowOnError extends boolean = true>(options?: Options<AuditLogListData, ThrowOnError>) {
        return (options?.client ?? client).get<AuditLogListResponse, AuditLogListError, ThrowOnError>({
            ...options,
            url: '/api/audit-log/'
        });
    }
    
    public static auditLogExportCsvCreate<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).post<AuditLogExportCsvCreateResponse, AuditLogExportCsvCreateError, ThrowOnError>({
            ...options,
            url: '/api/audit-log/export_csv/'
        });
    }
    
    /**
     * 'Deletes' a background asset by setting the archived flag on the asset.
     * This is implemented to only work for user uploaded background assets. Params:
     *
     * - type: the background asset type (image or video)
     * - id: the id of the asset
     */
    public static backgroundAssetsDestroy<ThrowOnError extends boolean = true>(options: Options<BackgroundAssetsDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<BackgroundAssetsDestroyResponse, BackgroundAssetsDestroyError, ThrowOnError>({
            ...options,
            url: '/api/background-assets/'
        });
    }
    
    public static backgroundRemovalCreate<ThrowOnError extends boolean = true>(options: Options<BackgroundRemovalCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<BackgroundRemovalCreateResponse, BackgroundRemovalCreateError, ThrowOnError>({
            ...options,
            url: '/api/background-removal/'
        });
    }
    
    public static batchTextToVoiceoverCreate<ThrowOnError extends boolean = true>(options: Options<BatchTextToVoiceoverCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<BatchTextToVoiceoverCreateResponse, BatchTextToVoiceoverCreateError, ThrowOnError>({
            ...options,
            url: '/api/batch_text_to_voiceover/'
        });
    }
    
    /**
     * list of charges & their details
     */
    public static billingChargesList<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<BillingChargesListResponse, BillingChargesListError, ThrowOnError>({
            ...options,
            url: '/api/billing/charges/'
        });
    }
    
    /**
     * modify and set team billing preferences
     */
    public static billingPreferencesRetrieve<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<BillingPreferencesRetrieveResponse, BillingPreferencesRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/billing/preferences/'
        });
    }
    
    /**
     * modify and set team billing preferences
     */
    public static billingPreferencesUpdate<ThrowOnError extends boolean = true>(options?: Options<BillingPreferencesUpdateData, ThrowOnError>) {
        return (options?.client ?? client).put<BillingPreferencesUpdateResponse, BillingPreferencesUpdateError, ThrowOnError>({
            ...options,
            url: '/api/billing/preferences/'
        });
    }
    
    /**
     * fetch, create, and delete receipt subscribers
     */
    public static billingSubscribersList<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<BillingSubscribersListResponse, BillingSubscribersListError, ThrowOnError>({
            ...options,
            url: '/api/billing/subscribers/'
        });
    }
    
    /**
     * fetch, create, and delete receipt subscribers
     */
    public static billingSubscribersCreate<ThrowOnError extends boolean = true>(options: Options<BillingSubscribersCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<BillingSubscribersCreateResponse, BillingSubscribersCreateError, ThrowOnError>({
            ...options,
            url: '/api/billing/subscribers/'
        });
    }
    
    /**
     * fetch, create, and delete receipt subscribers
     */
    public static billingSubscribersDestroy<ThrowOnError extends boolean = true>(options: Options<BillingSubscribersDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<BillingSubscribersDestroyResponse, BillingSubscribersDestroyError, ThrowOnError>({
            ...options,
            url: '/api/billing/subscribers/{id}/'
        });
    }
    
    /**
     * This endpoint automatically selects the best customer blueprint or recent video for a video based on input source content.
     */
    public static blueprintAutoPickCreate<ThrowOnError extends boolean = true>(options: Options<BlueprintAutoPickCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<BlueprintAutoPickCreateResponse, BlueprintAutoPickCreateError, ThrowOnError>({
            ...options,
            url: '/api/blueprint-auto-pick/'
        });
    }
    
    /**
     * Returns a list of blueprint recommendations
     */
    public static blueprintRecommendationsCreate<ThrowOnError extends boolean = true>(options: Options<BlueprintRecommendationsCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<BlueprintRecommendationsCreateResponse, BlueprintRecommendationsCreateError, ThrowOnError>({
            ...options,
            url: '/api/blueprint-recommendations/'
        });
    }
    
    /**
     * Read-only viewset for the workspace's blueprints.
     */
    public static blueprintsList<ThrowOnError extends boolean = true>(options?: Options<BlueprintsListData, ThrowOnError>) {
        return (options?.client ?? client).get<BlueprintsListResponse, BlueprintsListError, ThrowOnError>({
            ...options,
            url: '/api/blueprints/'
        });
    }
    
    /**
     * Read-only viewset for the workspace's blueprints.
     */
    public static blueprintsRetrieve<ThrowOnError extends boolean = true>(options: Options<BlueprintsRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<BlueprintsRetrieveResponse, BlueprintsRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/blueprints/{id}/'
        });
    }
    
    /**
     * Read-only viewset for the workspace's blueprints.
     */
    public static blueprintsTemplateStyleVideoDataRetrieve<ThrowOnError extends boolean = true>(options: Options<BlueprintsTemplateStyleVideoDataRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<BlueprintsTemplateStyleVideoDataRetrieveResponse, BlueprintsTemplateStyleVideoDataRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/blueprints/{id}/template-style-video-data/'
        });
    }
    
    /**
     * Fetch video_data for multiple blueprints by ID.
     * Used to generate Luminary previews for blueprints that don't have poster_url.
     */
    public static blueprintsVideoDataRetrieve<ThrowOnError extends boolean = true>(options: Options<BlueprintsVideoDataRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<BlueprintsVideoDataRetrieveResponse, BlueprintsVideoDataRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/blueprints/video-data/'
        });
    }
    
    public static brandKitsList<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<BrandKitsListResponse, BrandKitsListError, ThrowOnError>({
            ...options,
            url: '/api/brand-kits/'
        });
    }
    
    public static brandKitsCreate<ThrowOnError extends boolean = true>(options: Options<BrandKitsCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<BrandKitsCreateResponse, BrandKitsCreateError, ThrowOnError>({
            ...options,
            url: '/api/brand-kits/'
        });
    }
    
    public static brandKitsRetrieve<ThrowOnError extends boolean = true>(options: Options<BrandKitsRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<BrandKitsRetrieveResponse, BrandKitsRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/brand-kits/{id}/'
        });
    }
    
    public static brandKitsUpdate<ThrowOnError extends boolean = true>(options: Options<BrandKitsUpdateData, ThrowOnError>) {
        return (options?.client ?? client).put<BrandKitsUpdateResponse, BrandKitsUpdateError, ThrowOnError>({
            ...options,
            url: '/api/brand-kits/{id}/'
        });
    }
    
    public static brandKitsDestroy<ThrowOnError extends boolean = true>(options: Options<BrandKitsDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<BrandKitsDestroyResponse, BrandKitsDestroyError, ThrowOnError>({
            ...options,
            url: '/api/brand-kits/{id}/'
        });
    }
    
    public static brandKitsCountRetrieve<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<BrandKitsCountRetrieveResponse, BrandKitsCountRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/brand-kits/count/'
        });
    }
    
    public static bulkAssetSourceCreate<ThrowOnError extends boolean = true>(options: Options<BulkAssetSourceCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<BulkAssetSourceCreateResponse, BulkAssetSourceCreateError, ThrowOnError>({
            ...options,
            url: '/api/bulk-asset-source/'
        });
    }
    
    /**
     * This endpoint is used to retrieve asset details in bulk for assets by UUID.
     */
    public static bulkMediaAssetsList<ThrowOnError extends boolean = true>(options?: Options<BulkMediaAssetsListData, ThrowOnError>) {
        return (options?.client ?? client).get<BulkMediaAssetsListResponse, BulkMediaAssetsListError, ThrowOnError>({
            ...options,
            url: '/api/bulk-media-assets/'
        });
    }
    
    public static bulkTextSegmentationCreate<ThrowOnError extends boolean = true>(options: Options<BulkTextSegmentationCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<BulkTextSegmentationCreateResponse, BulkTextSegmentationCreateError, ThrowOnError>({
            ...options,
            url: '/api/bulk-text-segmentation/'
        });
    }
    
    public static changePasswordCreate<ThrowOnError extends boolean = true>(options: Options<ChangePasswordCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<ChangePasswordCreateResponse, ChangePasswordCreateError, ThrowOnError>({
            ...options,
            url: '/api/change-password/'
        });
    }
    
    /**
     * Changes the user's current active workspace
     */
    public static changeWorkspaceUpdate<ThrowOnError extends boolean = true>(options: Options<ChangeWorkspaceUpdateData, ThrowOnError>) {
        return (options?.client ?? client).put<ChangeWorkspaceUpdateResponse, ChangeWorkspaceUpdateError, ThrowOnError>({
            ...options,
            url: '/api/change-workspace/{workspace_id}/'
        });
    }
    
    /**
     * Returns chart style assets for the given chart type.
     * These are system assets (user=None) that serve as style references for AI chart generation.
     */
    public static chartStylesList<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<ChartStylesListResponse, ChartStylesListError, ThrowOnError>({
            ...options,
            url: '/api/chart-styles/'
        });
    }
    
    public static clicklogsclickCreate<ThrowOnError extends boolean = true>(options: Options<ClicklogsclickCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<ClicklogsclickCreateResponse, ClicklogsclickCreateError, ThrowOnError>({
            ...options,
            url: '/api/clicklogsclick/'
        });
    }
    
    public static clicklogsqueryCreate<ThrowOnError extends boolean = true>(options: Options<ClicklogsqueryCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<ClicklogsqueryCreateResponse, ClicklogsqueryCreateError, ThrowOnError>({
            ...options,
            url: '/api/clicklogsquery/'
        });
    }
    
    public static clicklogsrecommendationCreate<ThrowOnError extends boolean = true>(options: Options<ClicklogsrecommendationCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<ClicklogsrecommendationCreateResponse, ClicklogsrecommendationCreateError, ThrowOnError>({
            ...options,
            url: '/api/clicklogsrecommendation/'
        });
    }
    
    /**
     * This endpoint generates a list of "clip plan" options given some uploaded transcript.
     */
    public static clipPlannerCreate<ThrowOnError extends boolean = true>(options: Options<ClipPlannerCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<ClipPlannerCreateResponse, ClipPlannerCreateError, ThrowOnError>({
            ...options,
            url: '/api/clip-planner/'
        });
    }
    
    /**
     * List, create, update, and delete Codeo brands for the current workspace.
     */
    public static codeoBrandsList<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<CodeoBrandsListResponse, CodeoBrandsListError, ThrowOnError>({
            ...options,
            url: '/api/codeo-brands/'
        });
    }
    
    /**
     * List, create, update, and delete Codeo brands for the current workspace.
     */
    public static codeoBrandsCreate<ThrowOnError extends boolean = true>(options: Options<CodeoBrandsCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<CodeoBrandsCreateResponse, CodeoBrandsCreateError, ThrowOnError>({
            ...options,
            url: '/api/codeo-brands/'
        });
    }
    
    /**
     * List, create, update, and delete Codeo brands for the current workspace.
     */
    public static codeoBrandsUpdate<ThrowOnError extends boolean = true>(options: Options<CodeoBrandsUpdateData, ThrowOnError>) {
        return (options?.client ?? client).put<CodeoBrandsUpdateResponse, CodeoBrandsUpdateError, ThrowOnError>({
            ...options,
            url: '/api/codeo-brands/{id}/'
        });
    }
    
    /**
     * List, create, update, and delete Codeo brands for the current workspace.
     */
    public static codeoBrandsPartialUpdate<ThrowOnError extends boolean = true>(options: Options<CodeoBrandsPartialUpdateData, ThrowOnError>) {
        return (options?.client ?? client).patch<CodeoBrandsPartialUpdateResponse, CodeoBrandsPartialUpdateError, ThrowOnError>({
            ...options,
            url: '/api/codeo-brands/{id}/'
        });
    }
    
    /**
     * List, create, update, and delete Codeo brands for the current workspace.
     */
    public static codeoBrandsDestroy<ThrowOnError extends boolean = true>(options: Options<CodeoBrandsDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<CodeoBrandsDestroyResponse, CodeoBrandsDestroyError, ThrowOnError>({
            ...options,
            url: '/api/codeo-brands/{id}/'
        });
    }
    
    public static colorFilterList<ThrowOnError extends boolean = true>(options?: Options<ColorFilterListData, ThrowOnError>) {
        return (options?.client ?? client).get<ColorFilterListResponse, ColorFilterListError, ThrowOnError>({
            ...options,
            url: '/api/color-filter/'
        });
    }
    
    /**
     * Staff-only: query lightweight conversation summaries for analysis.
     * Returns counts + a preview + links instead of full message arrays.
     */
    public static listConversations<ThrowOnError extends boolean = true>(options?: Options<ListConversationsData, ThrowOnError>) {
        return (options?.client ?? client).get<ListConversationsResponse, ListConversationsError, ThrowOnError>({
            ...options,
            url: '/api/conversations/'
        });
    }
    
    /**
     * Save a conversation to the database.
     * Called explicitly by frontend after LLM interactions.
     */
    public static saveConversation<ThrowOnError extends boolean = true>(options: Options<SaveConversationData, ThrowOnError>) {
        return (options?.client ?? client).post<SaveConversationResponse2, SaveConversationError, ThrowOnError>({
            ...options,
            url: '/api/conversations/'
        });
    }
    
    /**
     * Get conversation details by ID. A user may fetch their own conversations.
     * Staff may fetch anyone's for debugging/analysis.
     */
    public static getConversation<ThrowOnError extends boolean = true>(options: Options<GetConversationData, ThrowOnError>) {
        return (options?.client ?? client).get<GetConversationResponse, GetConversationError, ThrowOnError>({
            ...options,
            url: '/api/conversations/{id}/'
        });
    }
    
    /**
     * Record that the user took the generated video forward (clicked Edit or
     * Download). Used as a success signal when reviewing toolbox sessions.
     */
    public static recordConversationInteraction<ThrowOnError extends boolean = true>(options: Options<RecordConversationInteractionData, ThrowOnError>) {
        return (options?.client ?? client).post<RecordConversationInteractionResponse, RecordConversationInteractionError, ThrowOnError>({
            ...options,
            url: '/api/conversations/{id}/record-interaction/'
        });
    }
    
    /**
     * Return the requesting user's most recent conversation for a video and task_type.
     */
    public static getLatestConversationForVideo<ThrowOnError extends boolean = true>(options: Options<GetLatestConversationForVideoData, ThrowOnError>) {
        return (options?.client ?? client).get<GetLatestConversationForVideoResponse, GetLatestConversationForVideoError, ThrowOnError>({
            ...options,
            url: '/api/conversations/latest-for-video/{video_id}/'
        });
    }
    
    public static copyMediaAssetsCreate<ThrowOnError extends boolean = true>(options: Options<CopyMediaAssetsCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<CopyMediaAssetsCreateResponse, CopyMediaAssetsCreateError, ThrowOnError>({
            ...options,
            url: '/api/copy-media-assets/'
        });
    }
    
    /**
     * Viewset for customer specific blueprints
     *
     * retrieve - can get customer-specific blueprints if the user has permission
     * list - get customer-specific blueprints if the user has permission
     * create_from_similar - create a new blueprint starting from a video and finding similar videos
     * create/delete/partial_update - customer specific blueprints if the user has permission
     * update - not implemented
     */
    public static customBlueprintsList<ThrowOnError extends boolean = true>(options?: Options<CustomBlueprintsListData, ThrowOnError>) {
        return (options?.client ?? client).get<CustomBlueprintsListResponse, CustomBlueprintsListError, ThrowOnError>({
            ...options,
            url: '/api/custom-blueprints/'
        });
    }
    
    /**
     * Viewset for customer specific blueprints
     *
     * retrieve - can get customer-specific blueprints if the user has permission
     * list - get customer-specific blueprints if the user has permission
     * create_from_similar - create a new blueprint starting from a video and finding similar videos
     * create/delete/partial_update - customer specific blueprints if the user has permission
     * update - not implemented
     */
    public static customBlueprintsCreate<ThrowOnError extends boolean = true>(options: Options<CustomBlueprintsCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<CustomBlueprintsCreateResponse, CustomBlueprintsCreateError, ThrowOnError>({
            ...options,
            url: '/api/custom-blueprints/'
        });
    }
    
    /**
     * Viewset for customer specific blueprints
     *
     * retrieve - can get customer-specific blueprints if the user has permission
     * list - get customer-specific blueprints if the user has permission
     * create_from_similar - create a new blueprint starting from a video and finding similar videos
     * create/delete/partial_update - customer specific blueprints if the user has permission
     * update - not implemented
     */
    public static customBlueprintsRetrieve<ThrowOnError extends boolean = true>(options: Options<CustomBlueprintsRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<CustomBlueprintsRetrieveResponse, CustomBlueprintsRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/custom-blueprints/{id}/'
        });
    }
    
    /**
     * Viewset for customer specific blueprints
     *
     * retrieve - can get customer-specific blueprints if the user has permission
     * list - get customer-specific blueprints if the user has permission
     * create_from_similar - create a new blueprint starting from a video and finding similar videos
     * create/delete/partial_update - customer specific blueprints if the user has permission
     * update - not implemented
     */
    public static customBlueprintsPartialUpdate<ThrowOnError extends boolean = true>(options: Options<CustomBlueprintsPartialUpdateData, ThrowOnError>) {
        return (options?.client ?? client).patch<CustomBlueprintsPartialUpdateResponse, CustomBlueprintsPartialUpdateError, ThrowOnError>({
            ...options,
            url: '/api/custom-blueprints/{id}/'
        });
    }
    
    /**
     * Archive the blueprint instead of permanently deleting it
     */
    public static customBlueprintsDestroy<ThrowOnError extends boolean = true>(options: Options<CustomBlueprintsDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<CustomBlueprintsDestroyResponse, CustomBlueprintsDestroyError, ThrowOnError>({
            ...options,
            url: '/api/custom-blueprints/{id}/'
        });
    }
    
    /**
     * Viewset for customer specific blueprints
     *
     * retrieve - can get customer-specific blueprints if the user has permission
     * list - get customer-specific blueprints if the user has permission
     * create_from_similar - create a new blueprint starting from a video and finding similar videos
     * create/delete/partial_update - customer specific blueprints if the user has permission
     * update - not implemented
     */
    public static customBlueprintsDuplicateCreate<ThrowOnError extends boolean = true>(options: Options<CustomBlueprintsDuplicateCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<CustomBlueprintsDuplicateCreateResponse, CustomBlueprintsDuplicateCreateError, ThrowOnError>({
            ...options,
            url: '/api/custom-blueprints/{id}/duplicate/'
        });
    }
    
    /**
     * Viewset for customer specific blueprints
     *
     * retrieve - can get customer-specific blueprints if the user has permission
     * list - get customer-specific blueprints if the user has permission
     * create_from_similar - create a new blueprint starting from a video and finding similar videos
     * create/delete/partial_update - customer specific blueprints if the user has permission
     * update - not implemented
     */
    public static customBlueprintsCreateFromSimilarCreate<ThrowOnError extends boolean = true>(options: Options<CustomBlueprintsCreateFromSimilarCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<CustomBlueprintsCreateFromSimilarCreateResponse, CustomBlueprintsCreateFromSimilarCreateError, ThrowOnError>({
            ...options,
            url: '/api/custom-blueprints/create_from_similar/'
        });
    }
    
    /**
     * This endpoint is used to search for media in a DAM provider.
     */
    public static damSearchCreate<ThrowOnError extends boolean = true>(options: Options<DamSearchCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<DamSearchCreateResponse, DamSearchCreateError, ThrowOnError>({
            ...options,
            url: '/api/dam-search/'
        });
    }
    
    /**
     * This endpoint is used to retrieve and update data metadata for a video.
     */
    public static datasetMetadataRetrieve<ThrowOnError extends boolean = true>(options: Options<DatasetMetadataRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<DatasetMetadataRetrieveResponse, DatasetMetadataRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/dataset-metadata/{id}/'
        });
    }
    
    /**
     * This endpoint is used to retrieve and update data metadata for a video.
     */
    public static datasetMetadataUpdate<ThrowOnError extends boolean = true>(options: Options<DatasetMetadataUpdateData, ThrowOnError>) {
        return (options?.client ?? client).put<DatasetMetadataUpdateResponse, DatasetMetadataUpdateError, ThrowOnError>({
            ...options,
            url: '/api/dataset-metadata/{id}/'
        });
    }
    
    /**
     * This endpoint is used to retrieve and update data metadata for a video.
     */
    public static datasetMetadataPartialUpdate<ThrowOnError extends boolean = true>(options: Options<DatasetMetadataPartialUpdateData, ThrowOnError>) {
        return (options?.client ?? client).patch<DatasetMetadataPartialUpdateResponse, DatasetMetadataPartialUpdateError, ThrowOnError>({
            ...options,
            url: '/api/dataset-metadata/{id}/'
        });
    }
    
    /**
     * This endpoint extracts pages from a document the user has attached
     */
    public static documentExtractCreate<ThrowOnError extends boolean = true>(options: Options<DocumentExtractCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<DocumentExtractCreateResponse, DocumentExtractCreateError, ThrowOnError>({
            ...options,
            url: '/api/document-extract/'
        });
    }
    
    public static documentResetUpdate<ThrowOnError extends boolean = true>(options: Options<DocumentResetUpdateData, ThrowOnError>) {
        return (options?.client ?? client).put<DocumentResetUpdateResponse, DocumentResetUpdateError, ThrowOnError>({
            ...options,
            url: '/api/document/reset/'
        });
    }
    
    /**
     * Creates a standalone Document (no Video required) and triggers text extraction.
     */
    public static documentsCreate<ThrowOnError extends boolean = true>(options: Options<DocumentsCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<DocumentsCreateResponse, DocumentsCreateError, ThrowOnError>({
            ...options,
            url: '/api/documents/'
        });
    }
    
    public static documentsImagesList<ThrowOnError extends boolean = true>(options: Options<DocumentsImagesListData, ThrowOnError>) {
        return (options?.client ?? client).get<DocumentsImagesListResponse, DocumentsImagesListError, ThrowOnError>({
            ...options,
            url: '/api/documents/{documents_pk}/images/'
        });
    }
    
    public static documentsImagesDestroy<ThrowOnError extends boolean = true>(options: Options<DocumentsImagesDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<DocumentsImagesDestroyResponse, DocumentsImagesDestroyError, ThrowOnError>({
            ...options,
            url: '/api/documents/{documents_pk}/images/{id}/'
        });
    }
    
    public static documentsImagesDeleteAllDestroy<ThrowOnError extends boolean = true>(options: Options<DocumentsImagesDeleteAllDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<DocumentsImagesDeleteAllDestroyResponse, DocumentsImagesDeleteAllDestroyError, ThrowOnError>({
            ...options,
            url: '/api/documents/{documents_pk}/images/delete_all/'
        });
    }
    
    /**
     * Triggers the task to create Document
     */
    public static documentsUpdate<ThrowOnError extends boolean = true>(options: Options<DocumentsUpdateData, ThrowOnError>) {
        return (options?.client ?? client).put<DocumentsUpdateResponse, DocumentsUpdateError, ThrowOnError>({
            ...options,
            url: '/api/documents/{id}/'
        });
    }
    
    public static documentsPartialUpdate<ThrowOnError extends boolean = true>(options: Options<DocumentsPartialUpdateData, ThrowOnError>) {
        return (options?.client ?? client).patch<DocumentsPartialUpdateResponse, DocumentsPartialUpdateError, ThrowOnError>({
            ...options,
            url: '/api/documents/{id}/'
        });
    }
    
    /**
     * The endpoint to edit AI voiceover audio file and transcript. This is used for several features:
     *
     * - Editing the transcript of an AI Voiceover (obviously!)
     * - Swapping the voice that an AI Voiceover uses
     * - Re-generating the AI Voice for a region of the transcript
     * - Translating an AI Voiceover scenegroup to a new language
     */
    public static editVoiceoverUpdate<ThrowOnError extends boolean = true>(options: Options<EditVoiceoverUpdateData, ThrowOnError>) {
        return (options?.client ?? client).put<EditVoiceoverUpdateResponse, EditVoiceoverUpdateError, ThrowOnError>({
            ...options,
            url: '/api/edit-voiceover/'
        });
    }
    
    /**
     * Asynchronously check if email exists in our DB
     */
    public static emailExistsCreate<ThrowOnError extends boolean = true>(options: Options<EmailExistsCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<EmailExistsCreateResponse, EmailExistsCreateError, ThrowOnError>({
            ...options,
            url: '/api/email-exists/'
        });
    }
    
    /**
     * Endpoint to check if a user has verified their email. Unauthenticated because it is
     * called from the confirm-email page (on tab-focus), where the user is not yet logged in.
     * Returns the verified flag plus an optional next_url so the caller can land on the same
     * destination the email-link path would (web/views.py:email_verification).
     */
    public static emailVerificationStatusRetrieve<ThrowOnError extends boolean = true>(options: Options<EmailVerificationStatusRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<EmailVerificationStatusRetrieveResponse, EmailVerificationStatusRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/email-verification-status/'
        });
    }
    
    public static faceDetectionCreate<ThrowOnError extends boolean = true>(options: Options<FaceDetectionCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<FaceDetectionCreateResponse, FaceDetectionCreateError, ThrowOnError>({
            ...options,
            url: '/api/face-detection/'
        });
    }
    
    /**
     * Retrieves all favorites so the frontend can star them in library tabs.
     */
    public static favoritesListMarkedFavoritesList<ThrowOnError extends boolean = true>(options?: Options<FavoritesListMarkedFavoritesListData, ThrowOnError>) {
        return (options?.client ?? client).get<FavoritesListMarkedFavoritesListResponse, FavoritesListMarkedFavoritesListError, ThrowOnError>({
            ...options,
            url: '/api/favorites/list_marked_favorites/'
        });
    }
    
    /**
     * Adds an asset to favorites indexes
     */
    public static favoritesMarkFavoriteCreate<ThrowOnError extends boolean = true>(options: Options<FavoritesMarkFavoriteCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<FavoritesMarkFavoriteCreateResponse, FavoritesMarkFavoriteCreateError, ThrowOnError>({
            ...options,
            url: '/api/favorites/mark_favorite/'
        });
    }
    
    /**
     * Removes an asset from favorites indexes
     */
    public static favoritesUnmarkFavoriteDestroy<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).delete<FavoritesUnmarkFavoriteDestroyResponse, FavoritesUnmarkFavoriteDestroyError, ThrowOnError>({
            ...options,
            url: '/api/favorites/unmark_favorite/'
        });
    }
    
    /**
     * Submit feedback for a chat/agent feature.
     *
     * The feature type is the root agent the feedback was given against; it selects
     * the Slack channel, falling back to #chat-feedback for anything unrecognized.
     */
    public static feedbackBetaCreate<ThrowOnError extends boolean = true>(options: Options<FeedbackBetaCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<FeedbackBetaCreateResponse, FeedbackBetaCreateError, ThrowOnError>({
            ...options,
            url: '/api/feedback/beta/'
        });
    }
    
    /**
     * Fetch media candidates for a video using the same pipeline as video creation.
     * Accepts optional media_options (including media_guidance) so the Improve Media
     * smart action can steer the search with user-provided guidance.
     * Returns a task_id for websocket listening; the task result is a MediaCandidates payload.
     */
    public static fetchMediaCandidatesCreate<ThrowOnError extends boolean = true>(options: Options<FetchMediaCandidatesCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<FetchMediaCandidatesCreateResponse, FetchMediaCandidatesCreateError, ThrowOnError>({
            ...options,
            url: '/api/fetch-media-candidates/'
        });
    }
    
    /**
     * This is a viewset for feature flags offering the following two custom actions:
     * - "enroll" endpoint which will opt-in the user to the specified feature flag
     * - if in DEBUG mode and the feature flag doesn't exist, will create it first
     * - "withdraw" endpoint which will opt-out the user from the specified feature flag
     */
    public static flagEnrollRetrieve<ThrowOnError extends boolean = true>(options: Options<FlagEnrollRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<FlagEnrollRetrieveResponse, FlagEnrollRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/flag/{id}/enroll/'
        });
    }
    
    /**
     * This is a viewset for feature flags offering the following two custom actions:
     * - "enroll" endpoint which will opt-in the user to the specified feature flag
     * - if in DEBUG mode and the feature flag doesn't exist, will create it first
     * - "withdraw" endpoint which will opt-out the user from the specified feature flag
     */
    public static flagWithdrawRetrieve<ThrowOnError extends boolean = true>(options: Options<FlagWithdrawRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<FlagWithdrawRetrieveResponse, FlagWithdrawRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/flag/{id}/withdraw/'
        });
    }
    
    /**
     * List all active feature flags with user's enrollment status (staff only)
     */
    public static flagListAllList<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<FlagListAllListResponse, FlagListAllListError, ThrowOnError>({
            ...options,
            url: '/api/flag/list_all/'
        });
    }
    
    public static fontAssetsList<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<FontAssetsListResponse, FontAssetsListError, ThrowOnError>({
            ...options,
            url: '/api/font-assets/'
        });
    }
    
    public static fontAssetsDestroy<ThrowOnError extends boolean = true>(options: Options<FontAssetsDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<FontAssetsDestroyResponse, FontAssetsDestroyError, ThrowOnError>({
            ...options,
            url: '/api/font-assets/{id}/'
        });
    }
    
    /**
     * Licenses a Freepik icon for the requesting user's team.
     * Called when the user drags a Freepik sticker onto the video.
     * If the team has already licensed this asset, returns success immediately.
     */
    public static freepikLicenseCreate<ThrowOnError extends boolean = true>(options: Options<FreepikLicenseCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<FreepikLicenseCreateResponse, FreepikLicenseCreateError, ThrowOnError>({
            ...options,
            url: '/api/freepik-license/'
        });
    }
    
    public static generateChartConfigCreate<ThrowOnError extends boolean = true>(options: Options<GenerateChartConfigCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<GenerateChartConfigCreateResponse, GenerateChartConfigCreateError, ThrowOnError>({
            ...options,
            url: '/api/generate-chart-config/'
        });
    }
    
    /**
     * This endpoint is used to generate media candidates for a video in the dataset.
     */
    public static generateMediaCandidatesCreate<ThrowOnError extends boolean = true>(options: Options<GenerateMediaCandidatesCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<GenerateMediaCandidatesCreateResponse, GenerateMediaCandidatesCreateError, ThrowOnError>({
            ...options,
            url: '/api/generate-media-candidates/{video_id}/'
        });
    }
    
    /**
     * This endpoint generates a script from a provided document (summarizing the document into a script).
     */
    public static generateScriptCreate<ThrowOnError extends boolean = true>(options: Options<GenerateScriptCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<GenerateScriptCreateResponse, GenerateScriptCreateError, ThrowOnError>({
            ...options,
            url: '/api/generate-script/'
        });
    }
    
    /**
     * This endpoint generates a script from a provided user prompt, enabling creating
     * a script from basically nothing or a few bullet points.
     */
    public static generateScriptFromPromptCreate<ThrowOnError extends boolean = true>(options: Options<GenerateScriptFromPromptCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<GenerateScriptFromPromptCreateResponse, GenerateScriptFromPromptCreateError, ThrowOnError>({
            ...options,
            url: '/api/generate-script-from-prompt/'
        });
    }
    
    /**
     * This endpoint generates a video recommendation, a series of scenes.
     */
    public static generateVideoRecommendationCreate<ThrowOnError extends boolean = true>(options: Options<GenerateVideoRecommendationCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<GenerateVideoRecommendationCreateResponse, GenerateVideoRecommendationCreateError, ThrowOnError>({
            ...options,
            url: '/api/generate-video-recommendation/'
        });
    }
    
    /**
     * This endpoint generates videos for a list of VideoPlans. This is used when showing a list of recommended videos
     * for the user to pick from.
     */
    public static generateVideosForVideoPlansCreate<ThrowOnError extends boolean = true>(options: Options<GenerateVideosForVideoPlansCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<GenerateVideosForVideoPlansCreateResponse, GenerateVideosForVideoPlansCreateError, ThrowOnError>({
            ...options,
            url: '/api/generate-videos-for-video-plans/'
        });
    }
    
    /**
     * Staff-only aggregate analytics across all GenX sessions.
     */
    public static genxAnalyticsRetrieve<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<GenxAnalyticsRetrieveResponse, GenxAnalyticsRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/genx-analytics/'
        });
    }
    
    public static genxEvalsEvalRunsList<ThrowOnError extends boolean = true>(options?: Options<GenxEvalsEvalRunsListData, ThrowOnError>) {
        return (options?.client ?? client).get<GenxEvalsEvalRunsListResponse, GenxEvalsEvalRunsListError, ThrowOnError>({
            ...options,
            url: '/api/genx-evals/eval-runs/'
        });
    }
    
    public static genxEvalsEvalRunsCreate<ThrowOnError extends boolean = true>(options: Options<GenxEvalsEvalRunsCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<GenxEvalsEvalRunsCreateResponse, GenxEvalsEvalRunsCreateError, ThrowOnError>({
            ...options,
            url: '/api/genx-evals/eval-runs/'
        });
    }
    
    public static genxEvalsEvalRunsRetrieve<ThrowOnError extends boolean = true>(options: Options<GenxEvalsEvalRunsRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<GenxEvalsEvalRunsRetrieveResponse, GenxEvalsEvalRunsRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/genx-evals/eval-runs/{id}/'
        });
    }
    
    public static genxEvalsEvalRunsPartialUpdate<ThrowOnError extends boolean = true>(options: Options<GenxEvalsEvalRunsPartialUpdateData, ThrowOnError>) {
        return (options?.client ?? client).patch<GenxEvalsEvalRunsPartialUpdateResponse, GenxEvalsEvalRunsPartialUpdateError, ThrowOnError>({
            ...options,
            url: '/api/genx-evals/eval-runs/{id}/'
        });
    }
    
    public static genxEvalsEvalRunsDestroy<ThrowOnError extends boolean = true>(options: Options<GenxEvalsEvalRunsDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<GenxEvalsEvalRunsDestroyResponse, GenxEvalsEvalRunsDestroyError, ThrowOnError>({
            ...options,
            url: '/api/genx-evals/eval-runs/{id}/'
        });
    }
    
    public static genxEvalsEvalRunsScriptsCreate<ThrowOnError extends boolean = true>(options: Options<GenxEvalsEvalRunsScriptsCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<GenxEvalsEvalRunsScriptsCreateResponse, GenxEvalsEvalRunsScriptsCreateError, ThrowOnError>({
            ...options,
            url: '/api/genx-evals/eval-runs/{id}/scripts/'
        });
    }
    
    public static genxEvalsEvalRunsScriptsIngredientsPartialUpdate<ThrowOnError extends boolean = true>(options: Options<GenxEvalsEvalRunsScriptsIngredientsPartialUpdateData, ThrowOnError>) {
        return (options?.client ?? client).patch<GenxEvalsEvalRunsScriptsIngredientsPartialUpdateResponse, GenxEvalsEvalRunsScriptsIngredientsPartialUpdateError, ThrowOnError>({
            ...options,
            url: '/api/genx-evals/eval-runs/scripts/{script_pk}/ingredients/'
        });
    }
    
    public static genxEvalsEvalSetsList<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<GenxEvalsEvalSetsListResponse, GenxEvalsEvalSetsListError, ThrowOnError>({
            ...options,
            url: '/api/genx-evals/eval-sets/'
        });
    }
    
    public static genxEvalsEvalSetsCreate<ThrowOnError extends boolean = true>(options: Options<GenxEvalsEvalSetsCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<GenxEvalsEvalSetsCreateResponse, GenxEvalsEvalSetsCreateError, ThrowOnError>({
            ...options,
            url: '/api/genx-evals/eval-sets/'
        });
    }
    
    public static genxEvalsEvalSetsRetrieve<ThrowOnError extends boolean = true>(options: Options<GenxEvalsEvalSetsRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<GenxEvalsEvalSetsRetrieveResponse, GenxEvalsEvalSetsRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/genx-evals/eval-sets/{id}/'
        });
    }
    
    public static genxEvalsEvalSetsUpdate<ThrowOnError extends boolean = true>(options: Options<GenxEvalsEvalSetsUpdateData, ThrowOnError>) {
        return (options?.client ?? client).put<GenxEvalsEvalSetsUpdateResponse, GenxEvalsEvalSetsUpdateError, ThrowOnError>({
            ...options,
            url: '/api/genx-evals/eval-sets/{id}/'
        });
    }
    
    public static genxEvalsEvalSetsPartialUpdate<ThrowOnError extends boolean = true>(options: Options<GenxEvalsEvalSetsPartialUpdateData, ThrowOnError>) {
        return (options?.client ?? client).patch<GenxEvalsEvalSetsPartialUpdateResponse, GenxEvalsEvalSetsPartialUpdateError, ThrowOnError>({
            ...options,
            url: '/api/genx-evals/eval-sets/{id}/'
        });
    }
    
    public static genxEvalsEvalSetsDestroy<ThrowOnError extends boolean = true>(options: Options<GenxEvalsEvalSetsDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<GenxEvalsEvalSetsDestroyResponse, GenxEvalsEvalSetsDestroyError, ThrowOnError>({
            ...options,
            url: '/api/genx-evals/eval-sets/{id}/'
        });
    }
    
    public static genxEvalsEvalSetsScriptsCreate<ThrowOnError extends boolean = true>(options: Options<GenxEvalsEvalSetsScriptsCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<GenxEvalsEvalSetsScriptsCreateResponse, GenxEvalsEvalSetsScriptsCreateError, ThrowOnError>({
            ...options,
            url: '/api/genx-evals/eval-sets/{id}/scripts/'
        });
    }
    
    public static genxEvalsGradesCreate<ThrowOnError extends boolean = true>(options: Options<GenxEvalsGradesCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<GenxEvalsGradesCreateResponse, GenxEvalsGradesCreateError, ThrowOnError>({
            ...options,
            url: '/api/genx-evals/grades/'
        });
    }
    
    public static genxEvalsGradesPartialUpdate<ThrowOnError extends boolean = true>(options: Options<GenxEvalsGradesPartialUpdateData, ThrowOnError>) {
        return (options?.client ?? client).patch<GenxEvalsGradesPartialUpdateResponse, GenxEvalsGradesPartialUpdateError, ThrowOnError>({
            ...options,
            url: '/api/genx-evals/grades/{id}/'
        });
    }
    
    public static genxEvalsGradesDestroy<ThrowOnError extends boolean = true>(options: Options<GenxEvalsGradesDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<GenxEvalsGradesDestroyResponse, GenxEvalsGradesDestroyError, ThrowOnError>({
            ...options,
            url: '/api/genx-evals/grades/{id}/'
        });
    }
    
    public static genxEvalsPresetsList<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<GenxEvalsPresetsListResponse, GenxEvalsPresetsListError, ThrowOnError>({
            ...options,
            url: '/api/genx-evals/presets/'
        });
    }
    
    public static genxEvalsPresetsScoreHistoryList<ThrowOnError extends boolean = true>(options: Options<GenxEvalsPresetsScoreHistoryListData, ThrowOnError>) {
        return (options?.client ?? client).get<GenxEvalsPresetsScoreHistoryListResponse, GenxEvalsPresetsScoreHistoryListError, ThrowOnError>({
            ...options,
            url: '/api/genx-evals/presets/{slug}/score-history/'
        });
    }
    
    public static genxEvalsScriptsPartialUpdate<ThrowOnError extends boolean = true>(options: Options<GenxEvalsScriptsPartialUpdateData, ThrowOnError>) {
        return (options?.client ?? client).patch<GenxEvalsScriptsPartialUpdateResponse, GenxEvalsScriptsPartialUpdateError, ThrowOnError>({
            ...options,
            url: '/api/genx-evals/scripts/{id}/'
        });
    }
    
    public static genxEvalsScriptsDestroy<ThrowOnError extends boolean = true>(options: Options<GenxEvalsScriptsDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<GenxEvalsScriptsDestroyResponse, GenxEvalsScriptsDestroyError, ThrowOnError>({
            ...options,
            url: '/api/genx-evals/scripts/{id}/'
        });
    }
    
    public static genxEvalsShotsPartialUpdate<ThrowOnError extends boolean = true>(options: Options<GenxEvalsShotsPartialUpdateData, ThrowOnError>) {
        return (options?.client ?? client).patch<GenxEvalsShotsPartialUpdateResponse, GenxEvalsShotsPartialUpdateError, ThrowOnError>({
            ...options,
            url: '/api/genx-evals/shots/{id}/'
        });
    }
    
    public static genxPresetBuilderScenariosList<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<GenxPresetBuilderScenariosListResponse, GenxPresetBuilderScenariosListError, ThrowOnError>({
            ...options,
            url: '/api/genx-preset-builder-scenarios/'
        });
    }
    
    public static genxPresetBuilderScenariosCreate<ThrowOnError extends boolean = true>(options: Options<GenxPresetBuilderScenariosCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<GenxPresetBuilderScenariosCreateResponse, GenxPresetBuilderScenariosCreateError, ThrowOnError>({
            ...options,
            url: '/api/genx-preset-builder-scenarios/'
        });
    }
    
    public static genxPresetBuilderScenariosUpdate<ThrowOnError extends boolean = true>(options: Options<GenxPresetBuilderScenariosUpdateData, ThrowOnError>) {
        return (options?.client ?? client).put<GenxPresetBuilderScenariosUpdateResponse, GenxPresetBuilderScenariosUpdateError, ThrowOnError>({
            ...options,
            url: '/api/genx-preset-builder-scenarios/{id}/'
        });
    }
    
    public static genxPresetBuilderScenariosPartialUpdate<ThrowOnError extends boolean = true>(options: Options<GenxPresetBuilderScenariosPartialUpdateData, ThrowOnError>) {
        return (options?.client ?? client).patch<GenxPresetBuilderScenariosPartialUpdateResponse, GenxPresetBuilderScenariosPartialUpdateError, ThrowOnError>({
            ...options,
            url: '/api/genx-preset-builder-scenarios/{id}/'
        });
    }
    
    public static genxPresetBuilderScenariosDestroy<ThrowOnError extends boolean = true>(options: Options<GenxPresetBuilderScenariosDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<GenxPresetBuilderScenariosDestroyResponse, GenxPresetBuilderScenariosDestroyError, ThrowOnError>({
            ...options,
            url: '/api/genx-preset-builder-scenarios/{id}/'
        });
    }
    
    /**
     * Ingredients previously created in the workspace's other GenX videos, newest first.
     */
    public static genxPreviousIngredientsList<ThrowOnError extends boolean = true>(options?: Options<GenxPreviousIngredientsListData, ThrowOnError>) {
        return (options?.client ?? client).get<GenxPreviousIngredientsListResponse, GenxPreviousIngredientsListError, ThrowOnError>({
            ...options,
            url: '/api/genx-previous-ingredients/'
        });
    }
    
    /**
     * List all GenX sessions. Staff only.
     */
    public static listGenxSessions<ThrowOnError extends boolean = true>(options?: Options<ListGenxSessionsData, ThrowOnError>) {
        return (options?.client ?? client).get<ListGenxSessionsResponse, ListGenxSessionsError, ThrowOnError>({
            ...options,
            url: '/api/genx-sessions/'
        });
    }
    
    /**
     * Create a new GenX observability session.
     *
     * The session is linked to its video at creation time so the viewer can
     * group every session for a video into one creation journey.
     */
    public static createGenxSession<ThrowOnError extends boolean = true>(options?: Options<CreateGenxSessionData, ThrowOnError>) {
        return (options?.client ?? client).post<CreateGenxSessionResponse, CreateGenxSessionError, ThrowOnError>({
            ...options,
            url: '/api/genx-sessions/'
        });
    }
    
    /**
     * Get full session details with events and aggregates. Staff only.
     */
    public static getGenxSession<ThrowOnError extends boolean = true>(options: Options<GetGenxSessionData, ThrowOnError>) {
        return (options?.client ?? client).get<GetGenxSessionResponse, GetGenxSessionError, ThrowOnError>({
            ...options,
            url: '/api/genx-sessions/{id}/'
        });
    }
    
    /**
     * Batch append events to a session. Must be the session owner.
     */
    public static appendGenxEvents<ThrowOnError extends boolean = true>(options: Options<AppendGenxEventsData, ThrowOnError>) {
        return (options?.client ?? client).post<AppendGenxEventsResponse, AppendGenxEventsError, ThrowOnError>({
            ...options,
            url: '/api/genx-sessions/{id}/events/'
        });
    }
    
    /**
     * Link a video to this session. Must be the session owner.
     */
    public static linkGenxSessionVideo<ThrowOnError extends boolean = true>(options: Options<LinkGenxSessionVideoData, ThrowOnError>) {
        return (options?.client ?? client).post<LinkGenxSessionVideoResponse, LinkGenxSessionVideoError, ThrowOnError>({
            ...options,
            url: '/api/genx-sessions/{id}/link-video/'
        });
    }
    
    /**
     * Returns active GEN-X style presets with their reference images.
     */
    public static genxStylePresetsList<ThrowOnError extends boolean = true>(options?: Options<GenxStylePresetsListData, ThrowOnError>) {
        return (options?.client ?? client).get<GenxStylePresetsListResponse, GenxStylePresetsListError, ThrowOnError>({
            ...options,
            url: '/api/genx-style-presets/'
        });
    }
    
    public static genxStylePresetsCreateCreate<ThrowOnError extends boolean = true>(options: Options<GenxStylePresetsCreateCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<GenxStylePresetsCreateCreateResponse, GenxStylePresetsCreateCreateError, ThrowOnError>({
            ...options,
            url: '/api/genx-style-presets/create/'
        });
    }
    
    public static getLanguageInfoForTextCreate<ThrowOnError extends boolean = true>(options: Options<GetLanguageInfoForTextCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<GetLanguageInfoForTextCreateResponse, GetLanguageInfoForTextCreateError, ThrowOnError>({
            ...options,
            url: '/api/get-language-info-for-text'
        });
    }
    
    public static htmlDesignSkillPreviewsList<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<HtmlDesignSkillPreviewsListResponse, HtmlDesignSkillPreviewsListError, ThrowOnError>({
            ...options,
            url: '/api/html-design/skill-previews/'
        });
    }
    
    public static htmlDesignSkillPreviewsCreate<ThrowOnError extends boolean = true>(options: Options<HtmlDesignSkillPreviewsCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<HtmlDesignSkillPreviewsCreateResponse, HtmlDesignSkillPreviewsCreateError, ThrowOnError>({
            ...options,
            url: '/api/html-design/skill-previews/'
        });
    }
    
    public static imageGenerationCreate<ThrowOnError extends boolean = true>(options: Options<ImageGenerationCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<ImageGenerationCreateResponse, ImageGenerationCreateError, ThrowOnError>({
            ...options,
            url: '/api/image-generation/'
        });
    }
    
    /**
     * Token-authed endpoint the claude-agent workflow POSTs its finished report to.
     * Auth is a django.core.signing token scoped to this report_id (no session).
     */
    public static internalRenderTriageReportCreate<ThrowOnError extends boolean = true>(options: Options<InternalRenderTriageReportCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<InternalRenderTriageReportCreateResponse, InternalRenderTriageReportCreateError, ThrowOnError>({
            ...options,
            url: '/api/internal/render-triage-report/{report_id}/'
        });
    }
    
    /**
     * Token-authed read endpoint the agent uses to cross-reference recent reports.
     */
    public static internalRenderTriageReportsRecentRetrieve<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<InternalRenderTriageReportsRecentRetrieveResponse, InternalRenderTriageReportsRecentRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/internal/render-triage-reports/recent/'
        });
    }
    
    public static isAuthenticatedRetrieve<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<IsAuthenticatedRetrieveResponse, IsAuthenticatedRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/is-authenticated/'
        });
    }
    
    /**
     * Logs media agent results for analysis of feature flag experiments.
     * Logs are output as JSON to the media_agent_results logger.
     */
    public static logMediaAgentResultsCreate<ThrowOnError extends boolean = true>(options: Options<LogMediaAgentResultsCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<LogMediaAgentResultsCreateResponse, LogMediaAgentResultsCreateError, ThrowOnError>({
            ...options,
            url: '/api/log-media-agent-results/'
        });
    }
    
    public static longestSupportedDurationTargetsCreate<ThrowOnError extends boolean = true>(options: Options<LongestSupportedDurationTargetsCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<LongestSupportedDurationTargetsCreateResponse, LongestSupportedDurationTargetsCreateError, ThrowOnError>({
            ...options,
            url: '/api/longest-supported-duration-targets/'
        });
    }
    
    /**
     * A ViewSet for retrieving the text representation of a media asset by UUID.
     */
    public static mediaAssetTextRepresentationRetrieve<ThrowOnError extends boolean = true>(options: Options<MediaAssetTextRepresentationRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<MediaAssetTextRepresentationRetrieveResponse, MediaAssetTextRepresentationRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/media-asset-text-representation/{media_asset_uuid}/'
        });
    }
    
    /**
     * Preview endpoint for media concepts. Triggers an async task to fetch preview thumbnails
     * using the same get_media_candidates_using_cache pipeline as video creation.
     * Returns a task_id for websocket listening.
     */
    public static mediaConceptPreviewCreate<ThrowOnError extends boolean = true>(options: Options<MediaConceptPreviewCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<MediaConceptPreviewCreateResponse, MediaConceptPreviewCreateError, ThrowOnError>({
            ...options,
            url: '/api/media-concept-preview/'
        });
    }
    
    public static mediaFoldersList<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<MediaFoldersListResponse, MediaFoldersListError, ThrowOnError>({
            ...options,
            url: '/api/media-folders/'
        });
    }
    
    public static mediaFoldersCreate<ThrowOnError extends boolean = true>(options?: Options<MediaFoldersCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<MediaFoldersCreateResponse, MediaFoldersCreateError, ThrowOnError>({
            ...options,
            url: '/api/media-folders/'
        });
    }
    
    public static mediaFoldersRetrieve<ThrowOnError extends boolean = true>(options: Options<MediaFoldersRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<MediaFoldersRetrieveResponse, MediaFoldersRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/media-folders/{id}/'
        });
    }
    
    public static mediaFoldersPartialUpdate<ThrowOnError extends boolean = true>(options: Options<MediaFoldersPartialUpdateData, ThrowOnError>) {
        return (options?.client ?? client).patch<MediaFoldersPartialUpdateResponse, MediaFoldersPartialUpdateError, ThrowOnError>({
            ...options,
            url: '/api/media-folders/{id}/'
        });
    }
    
    public static mediaFoldersDestroy<ThrowOnError extends boolean = true>(options: Options<MediaFoldersDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<MediaFoldersDestroyResponse, MediaFoldersDestroyError, ThrowOnError>({
            ...options,
            url: '/api/media-folders/{id}/'
        });
    }
    
    public static mediaSearchCreate<ThrowOnError extends boolean = true>(options?: Options<MediaSearchCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<MediaSearchCreateResponse, MediaSearchCreateError, ThrowOnError>({
            ...options,
            url: '/api/media-search/'
        });
    }
    
    public static mergeTeamsCreate<ThrowOnError extends boolean = true>(options: Options<MergeTeamsCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<MergeTeamsCreateResponse, MergeTeamsCreateError, ThrowOnError>({
            ...options,
            url: '/api/merge-teams/'
        });
    }
    
    /**
     * Proxy some frontend events to be server-fired. This ensures they're always sent.
     */
    public static mixyCreate<ThrowOnError extends boolean = true>(options: Options<MixyCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<MixyCreateResponse, MixyCreateError, ThrowOnError>({
            ...options,
            url: '/api/mixy/'
        });
    }
    
    public static musicRecommendationCreate<ThrowOnError extends boolean = true>(options: Options<MusicRecommendationCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<MusicRecommendationCreateResponse, MusicRecommendationCreateError, ThrowOnError>({
            ...options,
            url: '/api/music_recommendation/'
        });
    }
    
    public static nameSuggestionCreate<ThrowOnError extends boolean = true>(options: Options<NameSuggestionCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<NameSuggestionCreateResponse, NameSuggestionCreateError, ThrowOnError>({
            ...options,
            url: '/api/name-suggestion/'
        });
    }
    
    /**
     * In-app notifications to keep track of things like rendering success/fail, comments, and approvals
     */
    public static notificationsList<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<NotificationsListResponse, NotificationsListError, ThrowOnError>({
            ...options,
            url: '/api/notifications/'
        });
    }
    
    /**
     * In-app notifications to keep track of things like rendering success/fail, comments, and approvals
     */
    public static notificationsMarkAsReadPartialUpdate<ThrowOnError extends boolean = true>(options: Options<NotificationsMarkAsReadPartialUpdateData, ThrowOnError>) {
        return (options?.client ?? client).patch<NotificationsMarkAsReadPartialUpdateResponse, NotificationsMarkAsReadPartialUpdateError, ThrowOnError>({
            ...options,
            url: '/api/notifications/{id}/mark_as_read/'
        });
    }
    
    /**
     * In-app notifications to keep track of things like rendering success/fail, comments, and approvals
     */
    public static notificationsMarkAllAsReadPartialUpdate<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).patch<NotificationsMarkAllAsReadPartialUpdateResponse, NotificationsMarkAllAsReadPartialUpdateError, ThrowOnError>({
            ...options,
            url: '/api/notifications/mark_all_as_read/'
        });
    }
    
    /**
     * In-app notifications to keep track of things like rendering success/fail, comments, and approvals
     */
    public static notificationsNumUnreadRetrieve<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<NotificationsNumUnreadRetrieveResponse, NotificationsNumUnreadRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/notifications/num_unread/'
        });
    }
    
    /**
     * Handles the submission of the forgot-password form.
     */
    public static passwordForgotCreate<ThrowOnError extends boolean = true>(options: Options<PasswordForgotCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<PasswordForgotCreateResponse, PasswordForgotCreateError, ThrowOnError>({
            ...options,
            url: '/api/password/forgot/'
        });
    }
    
    /**
     * Handles password resets from the reset password form.
     */
    public static passwordResetCreate<ThrowOnError extends boolean = true>(options: Options<PasswordResetCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<PasswordResetCreateResponse, PasswordResetCreateError, ThrowOnError>({
            ...options,
            url: '/api/password/reset/'
        });
    }
    
    /**
     * Prefetches media candidates for a given script & media settings for faster video generation.
     */
    public static prefetchMediaCandidatesCreate<ThrowOnError extends boolean = true>(options: Options<PrefetchMediaCandidatesCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<PrefetchMediaCandidatesCreateResponse, PrefetchMediaCandidatesCreateError, ThrowOnError>({
            ...options,
            url: '/api/prefetch-media-candidates/'
        });
    }
    
    public static premiumMediaCreditCheckCreate<ThrowOnError extends boolean = true>(options: Options<PremiumMediaCreditCheckCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<PremiumMediaCreditCheckCreateResponse, PremiumMediaCreditCheckCreateError, ThrowOnError>({
            ...options,
            url: '/api/premium-media-credit-check/'
        });
    }
    
    /**
     * params:
     * reason: The selected reason for cancellation (optional)
     * other_reason: If other reason the user provided reason (optional)
     * feedback: General feedback for improvement (optional)
     * is_genx_feedback: True when the feedback originates from the GenX
     * animation-minutes cancellation flow. Routes Slack to a separate
     * channel, renames the Mixpanel event, and skips the HubSpot event
     * (which is tied to plan-level subscription churn).
     */
    public static pricingCancellationFeedbackCreate<ThrowOnError extends boolean = true>(options?: Options<PricingCancellationFeedbackCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<PricingCancellationFeedbackCreateResponse, PricingCancellationFeedbackCreateError, ThrowOnError>({
            ...options,
            url: '/api/pricing/cancellation_feedback/'
        });
    }
    
    public static pricingCreditCardDetailsRetrieve<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<PricingCreditCardDetailsRetrieveResponse, PricingCreditCardDetailsRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/pricing/credit-card-details/'
        });
    }
    
    public static pricingCurrentPlanNameRetrieve<ThrowOnError extends boolean = true>(options?: Options<PricingCurrentPlanNameRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<PricingCurrentPlanNameRetrieveResponse, PricingCurrentPlanNameRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/pricing/current-plan-name/'
        });
    }
    
    /**
     * This api is used for changing payment method
     */
    public static pricingPaymentMethodCheckoutUpdate<ThrowOnError extends boolean = true>(options?: Options<PricingPaymentMethodCheckoutUpdateData, ThrowOnError>) {
        return (options?.client ?? client).put<PricingPaymentMethodCheckoutUpdateResponse, PricingPaymentMethodCheckoutUpdateError, ThrowOnError>({
            ...options,
            url: '/api/pricing/payment-method-checkout/'
        });
    }
    
    public static pricingPaymentMethodStatusRetrieve<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<PricingPaymentMethodStatusRetrieveResponse, PricingPaymentMethodStatusRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/pricing/payment_method_status/'
        });
    }
    
    public static pricingPlansRetrieve<ThrowOnError extends boolean = true>(options?: Options<PricingPlansRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<PricingPlansRetrieveResponse, PricingPlansRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/pricing/plans/'
        });
    }
    
    public static pricingPremiumMediaRetrieve<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<PricingPremiumMediaRetrieveResponse, PricingPremiumMediaRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/pricing/premium-media/'
        });
    }
    
    /**
     * This updates a team's subscription to no longer cancel at the end of the billing cycle
     */
    public static pricingRenewSubscriptionCreate<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).post<PricingRenewSubscriptionCreateResponse, PricingRenewSubscriptionCreateError, ThrowOnError>({
            ...options,
            url: '/api/pricing/renew_subscription/'
        });
    }
    
    public static pricingSubscriptionRetrieve<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<PricingSubscriptionRetrieveResponse, PricingSubscriptionRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/pricing/subscription/'
        });
    }
    
    /**
     * Initiates a checkout session with stripe, used for new customers or customers
     * without a valid payment method.
     */
    public static pricingSubscriptionCreate<ThrowOnError extends boolean = true>(options?: Options<PricingSubscriptionCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<PricingSubscriptionCreateResponse, PricingSubscriptionCreateError, ThrowOnError>({
            ...options,
            url: '/api/pricing/subscription/'
        });
    }
    
    /**
     * Used to update a subscription for an existing customer.
     */
    public static pricingSubscriptionPartialUpdate<ThrowOnError extends boolean = true>(options?: Options<PricingSubscriptionPartialUpdateData, ThrowOnError>) {
        return (options?.client ?? client).patch<PricingSubscriptionPartialUpdateResponse, PricingSubscriptionPartialUpdateError, ThrowOnError>({
            ...options,
            url: '/api/pricing/subscription/'
        });
    }
    
    /**
     * Pause a subscription for a specified duration or indefinitely.
     */
    public static pricingSubscriptionPauseCreate<ThrowOnError extends boolean = true>(options?: Options<PricingSubscriptionPauseCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<PricingSubscriptionPauseCreateResponse, PricingSubscriptionPauseCreateError, ThrowOnError>({
            ...options,
            url: '/api/pricing/subscription/pause/'
        });
    }
    
    /**
     * Preview the prorated charge for a pending subscription change.
     *
     * GET query params mirror SubscriptionUpdateSerializer (genx_addon_name, genx_addon_quantity,
     * plan_name, seat_quantity). Initial frontend use case is addon previews.
     */
    public static pricingSubscriptionPreviewRetrieve<ThrowOnError extends boolean = true>(options: Options<PricingSubscriptionPreviewRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<PricingSubscriptionPreviewRetrieveResponse, PricingSubscriptionPreviewRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/pricing/subscription/preview/'
        });
    }
    
    /**
     * Resume a paused subscription immediately.
     */
    public static pricingSubscriptionResumeCreate<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).post<PricingSubscriptionResumeCreateResponse, PricingSubscriptionResumeCreateError, ThrowOnError>({
            ...options,
            url: '/api/pricing/subscription/resume/'
        });
    }
    
    public static projectsList<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<ProjectsListResponse, ProjectsListError, ThrowOnError>({
            ...options,
            url: '/api/projects/'
        });
    }
    
    public static projectsCreate<ThrowOnError extends boolean = true>(options?: Options<ProjectsCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<ProjectsCreateResponse, ProjectsCreateError, ThrowOnError>({
            ...options,
            url: '/api/projects/'
        });
    }
    
    public static projectsRetrieve<ThrowOnError extends boolean = true>(options: Options<ProjectsRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<ProjectsRetrieveResponse, ProjectsRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/projects/{id}/'
        });
    }
    
    public static projectsPartialUpdate<ThrowOnError extends boolean = true>(options: Options<ProjectsPartialUpdateData, ThrowOnError>) {
        return (options?.client ?? client).patch<ProjectsPartialUpdateResponse, ProjectsPartialUpdateError, ThrowOnError>({
            ...options,
            url: '/api/projects/{id}/'
        });
    }
    
    public static projectsDestroy<ThrowOnError extends boolean = true>(options: Options<ProjectsDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<ProjectsDestroyResponse, ProjectsDestroyError, ThrowOnError>({
            ...options,
            url: '/api/projects/{id}/'
        });
    }
    
    public static projectsBulkUpdateMembersCreate<ThrowOnError extends boolean = true>(options: Options<ProjectsBulkUpdateMembersCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<ProjectsBulkUpdateMembersCreateResponse, ProjectsBulkUpdateMembersCreateError, ThrowOnError>({
            ...options,
            url: '/api/projects/bulk-update-members/'
        });
    }
    
    public static pronunciationList<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<PronunciationListResponse, PronunciationListError, ThrowOnError>({
            ...options,
            url: '/api/pronunciation/'
        });
    }
    
    /**
     * Upsert Pronunciation object to team's Pronunciation dictionary
     */
    public static pronunciationUpsert<ThrowOnError extends boolean = true>(options: Options<PronunciationUpsertData, ThrowOnError>) {
        return (options?.client ?? client).put<PronunciationUpsertResponse, PronunciationUpsertError, ThrowOnError>({
            ...options,
            url: '/api/pronunciation/'
        });
    }
    
    public static pronunciationDestroy<ThrowOnError extends boolean = true>(options: Options<PronunciationDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<PronunciationDestroyResponse, PronunciationDestroyError, ThrowOnError>({
            ...options,
            url: '/api/pronunciation/{id}/'
        });
    }
    
    /**
     * A simple endpoint that is exposed publicly so that anyone can view the
     * video (if the link is shared by email or something). This endpoint
     * should not return any personally identifiable information!
     */
    public static publicVideoRetrieve<ThrowOnError extends boolean = true>(options: Options<PublicVideoRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<PublicVideoRetrieveResponse, PublicVideoRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/public-video/{slug}/'
        });
    }
    
    /**
     * Video has errored if a video has published which started rendering
     * 30+ mins after it
     * If we have >= 50 videos in the queue, report 'rendering' as we likely
     * have an issue
     */
    public static queueEstimatedRenderDurationRetrieve<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<QueueEstimatedRenderDurationRetrieveResponse, QueueEstimatedRenderDurationRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/queue/estimated_render_duration/'
        });
    }
    
    /**
     * Returns relevant rendering details for a video
     */
    public static queueVideoRenderDetailsRetrieve<ThrowOnError extends boolean = true>(options: Options<QueueVideoRenderDetailsRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<QueueVideoRenderDetailsRetrieveResponse, QueueVideoRenderDetailsRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/queue/video_render_details/{video_id}/'
        });
    }
    
    /**
     * Returns last 3 templates used to publish videos.
     */
    public static recentlyUsedTemplatesList<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<RecentlyUsedTemplatesListResponse, RecentlyUsedTemplatesListError, ThrowOnError>({
            ...options,
            url: '/api/recently_used_templates/'
        });
    }
    
    public static regenerateTranscriptForAssetCreate<ThrowOnError extends boolean = true>(options: Options<RegenerateTranscriptForAssetCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<RegenerateTranscriptForAssetCreateResponse, RegenerateTranscriptForAssetCreateError, ThrowOnError>({
            ...options,
            url: '/api/regenerate-transcript-for-asset/'
        });
    }
    
    public static regenerateMfaBackupKeysCreate<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).post<RegenerateMfaBackupKeysCreateResponse, RegenerateMfaBackupKeysCreateError, ThrowOnError>({
            ...options,
            url: '/api/regenerate_mfa_backup_keys/'
        });
    }
    
    /**
     * Receives results from the render-diagnostic page and posts them to Slack. Requires auth so the
     * reporter's identity comes from the session, not from the submitted report.
     */
    public static renderDiagnosticsCreate<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).post<RenderDiagnosticsCreateResponse, RenderDiagnosticsCreateError, ThrowOnError>({
            ...options,
            url: '/api/render-diagnostics/'
        });
    }
    
    /**
     * The luminary bundle that was live about `days` ago, for the render-diagnostic page.
     */
    public static renderDiagnosticsBaselineBundleRetrieve<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<RenderDiagnosticsBaselineBundleRetrieveResponse, RenderDiagnosticsBaselineBundleRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/render-diagnostics/baseline-bundle/'
        });
    }
    
    public static resolveCommentsCreate<ThrowOnError extends boolean = true>(options: Options<ResolveCommentsCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<ResolveCommentsCreateResponse, ResolveCommentsCreateError, ThrowOnError>({
            ...options,
            url: '/api/resolve_comments/'
        });
    }
    
    /**
     * This endpoint saves video data (luminary state) to GCS bucket and returns a UUID and URL
     * for later retrieval. Used for logging video states during agent conversations.
     */
    public static saveVideoDataSnapshotCreate<ThrowOnError extends boolean = true>(options: Options<SaveVideoDataSnapshotCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<SaveVideoDataSnapshotCreateResponse, SaveVideoDataSnapshotCreateError, ThrowOnError>({
            ...options,
            url: '/api/save-video-data-snapshot/'
        });
    }
    
    /**
     * Fetches the recommended scene attributes to optimize content on a scene. Returns information
     * for the ideal crop, brightness, scene design, background animation, etc.
     */
    public static sceneAttributesList<ThrowOnError extends boolean = true>(options: Options<SceneAttributesListData, ThrowOnError>) {
        return (options?.client ?? client).get<SceneAttributesListResponse, SceneAttributesListError, ThrowOnError>({
            ...options,
            url: '/api/scene-attributes/'
        });
    }
    
    public static sceneDesignsList<ThrowOnError extends boolean = true>(options: Options<SceneDesignsListData, ThrowOnError>) {
        return (options?.client ?? client).get<SceneDesignsListResponse, SceneDesignsListError, ThrowOnError>({
            ...options,
            url: '/api/scene-designs/'
        });
    }
    
    public static sceneDesignsCreate<ThrowOnError extends boolean = true>(options: Options<SceneDesignsCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<SceneDesignsCreateResponse, SceneDesignsCreateError, ThrowOnError>({
            ...options,
            url: '/api/scene-designs/'
        });
    }
    
    public static sceneDesignsRetrieve<ThrowOnError extends boolean = true>(options: Options<SceneDesignsRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<SceneDesignsRetrieveResponse, SceneDesignsRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/scene-designs/{id}/'
        });
    }
    
    public static sceneDesignsUpdate<ThrowOnError extends boolean = true>(options: Options<SceneDesignsUpdateData, ThrowOnError>) {
        return (options?.client ?? client).put<SceneDesignsUpdateResponse, SceneDesignsUpdateError, ThrowOnError>({
            ...options,
            url: '/api/scene-designs/{id}/'
        });
    }
    
    public static sceneDesignsPartialUpdate<ThrowOnError extends boolean = true>(options: Options<SceneDesignsPartialUpdateData, ThrowOnError>) {
        return (options?.client ?? client).patch<SceneDesignsPartialUpdateResponse, SceneDesignsPartialUpdateError, ThrowOnError>({
            ...options,
            url: '/api/scene-designs/{id}/'
        });
    }
    
    public static sceneDesignsDestroy<ThrowOnError extends boolean = true>(options: Options<SceneDesignsDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<SceneDesignsDestroyResponse, SceneDesignsDestroyError, ThrowOnError>({
            ...options,
            url: '/api/scene-designs/{id}/'
        });
    }
    
    public static sceneDesignsBulkUpdateUpdate<ThrowOnError extends boolean = true>(options: Options<SceneDesignsBulkUpdateUpdateData, ThrowOnError>) {
        return (options?.client ?? client).put<SceneDesignsBulkUpdateUpdateResponse, SceneDesignsBulkUpdateUpdateError, ThrowOnError>({
            ...options,
            url: '/api/scene-designs/bulk_update/'
        });
    }
    
    public static sceneDesignsIdsPerTemplateList<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<SceneDesignsIdsPerTemplateListResponse, SceneDesignsIdsPerTemplateListError, ThrowOnError>({
            ...options,
            url: '/api/scene-designs/ids_per_template/'
        });
    }
    
    public static sceneDesignsTemplateAnnotationsRetrieve<ThrowOnError extends boolean = true>(options: Options<SceneDesignsTemplateAnnotationsRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<SceneDesignsTemplateAnnotationsRetrieveResponse, SceneDesignsTemplateAnnotationsRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/scene-designs/template_annotations/'
        });
    }
    
    /**
     * We currently support two versions here:
     * 1 = Script Composer (no duration targeting)
     * 2 = Script Composer (with duration targeting)
     */
    public static scriptOptionsCreate<ThrowOnError extends boolean = true>(options: Options<ScriptOptionsCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<ScriptOptionsCreateResponse, ScriptOptionsCreateError, ThrowOnError>({
            ...options,
            url: '/api/script-options/'
        });
    }
    
    /**
     * Endpoint to send email verification email. The user is not authenticated so user_id must be provided to look up the user.
     */
    public static sendEmailVerificationCreate<ThrowOnError extends boolean = true>(options: Options<SendEmailVerificationCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<SendEmailVerificationCreateResponse, SendEmailVerificationCreateError, ThrowOnError>({
            ...options,
            url: '/api/send-email-verification/'
        });
    }
    
    public static sendMfaRecoveryCodeCreate<ThrowOnError extends boolean = true>(options: Options<SendMfaRecoveryCodeCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<SendMfaRecoveryCodeCreateResponse, SendMfaRecoveryCodeCreateError, ThrowOnError>({
            ...options,
            url: '/api/send-mfa-recovery-code/'
        });
    }
    
    public static shareGptFeedbackCreate<ThrowOnError extends boolean = true>(options: Options<ShareGptFeedbackCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<ShareGptFeedbackCreateResponse, ShareGptFeedbackCreateError, ThrowOnError>({
            ...options,
            url: '/api/share-gpt-feedback/'
        });
    }
    
    public static simpleTextCorrectionCreate<ThrowOnError extends boolean = true>(options: Options<SimpleTextCorrectionCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<SimpleTextCorrectionCreateResponse, SimpleTextCorrectionCreateError, ThrowOnError>({
            ...options,
            url: '/api/simple-text-correction/'
        });
    }
    
    /**
     * API endpoint that returns sketch context information including template options,
     * blueprint options, and user video history.
     */
    public static sketchContextInfoRetrieve<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<SketchContextInfoRetrieveResponse, SketchContextInfoRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/sketch/context/info/'
        });
    }
    
    /**
     * This endpoint executes sketch research workflow.
     */
    public static sketchResearchCreate<ThrowOnError extends boolean = true>(options: Options<SketchResearchCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<SketchResearchCreateResponse, SketchResearchCreateError, ThrowOnError>({
            ...options,
            url: '/api/sketch/research/'
        });
    }
    
    /**
     * This endpoint fetches content from user message
     */
    public static sketchUrlFetchCreate<ThrowOnError extends boolean = true>(options: Options<SketchUrlFetchCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<SketchUrlFetchCreateResponse, SketchUrlFetchCreateError, ThrowOnError>({
            ...options,
            url: '/api/sketch/url-fetch/'
        });
    }
    
    /**
     * This endpoint takes a list of video plans and validates them
     * using the existing VideoPlanValidator logic. It returns either validated
     * VideoPlan objects or detailed error messages.
     */
    public static sketchValidateVideoPlansCreate<ThrowOnError extends boolean = true>(options: Options<SketchValidateVideoPlansCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<SketchValidateVideoPlansCreateResponse, SketchValidateVideoPlansCreateError, ThrowOnError>({
            ...options,
            url: '/api/sketch/validate-video-plans/'
        });
    }
    
    /**
     * This endpoint allows users to search for images using Google Custom Search API
     * and returns asset UUIDs for the found images that can be used in video generation.
     */
    public static sketchWebImageSearchCreate<ThrowOnError extends boolean = true>(options: Options<SketchWebImageSearchCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<SketchWebImageSearchCreateResponse, SketchWebImageSearchCreateError, ThrowOnError>({
            ...options,
            url: '/api/sketch/web-image-search/'
        });
    }
    
    /**
     * Returns active sound effect styles.
     */
    public static soundEffectStylesList<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<SoundEffectStylesListResponse, SoundEffectStylesListError, ThrowOnError>({
            ...options,
            url: '/api/sound-effect-styles/'
        });
    }
    
    /**
     * Returns sound effects from the library, optionally filtered by style.
     */
    public static soundEffectsList<ThrowOnError extends boolean = true>(options?: Options<SoundEffectsListData, ThrowOnError>) {
        return (options?.client ?? client).get<SoundEffectsListResponse, SoundEffectsListError, ThrowOnError>({
            ...options,
            url: '/api/sound-effects/'
        });
    }
    
    public static ssoIdpConfigCreate<ThrowOnError extends boolean = true>(options: Options<SsoIdpConfigCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<SsoIdpConfigCreateResponse, SsoIdpConfigCreateError, ThrowOnError>({
            ...options,
            url: '/api/sso-idp-config/'
        });
    }
    
    public static ssoIdpConfigRetrieve<ThrowOnError extends boolean = true>(options: Options<SsoIdpConfigRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<SsoIdpConfigRetrieveResponse, SsoIdpConfigRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/sso-idp-config/{id}/'
        });
    }
    
    public static ssoIdpConfigUpdate<ThrowOnError extends boolean = true>(options: Options<SsoIdpConfigUpdateData, ThrowOnError>) {
        return (options?.client ?? client).put<SsoIdpConfigUpdateResponse, SsoIdpConfigUpdateError, ThrowOnError>({
            ...options,
            url: '/api/sso-idp-config/{id}/'
        });
    }
    
    public static ssoIdpConfigPartialUpdate<ThrowOnError extends boolean = true>(options: Options<SsoIdpConfigPartialUpdateData, ThrowOnError>) {
        return (options?.client ?? client).patch<SsoIdpConfigPartialUpdateResponse, SsoIdpConfigPartialUpdateError, ThrowOnError>({
            ...options,
            url: '/api/sso-idp-config/{id}/'
        });
    }
    
    public static ssoIdpConfigDestroy<ThrowOnError extends boolean = true>(options: Options<SsoIdpConfigDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<SsoIdpConfigDestroyResponse, SsoIdpConfigDestroyError, ThrowOnError>({
            ...options,
            url: '/api/sso-idp-config/{id}/'
        });
    }
    
    /**
     * Check if the user can signup/login with SSO
     */
    public static ssoVerficationCreate<ThrowOnError extends boolean = true>(options?: Options<SsoVerficationCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<SsoVerficationCreateResponse, SsoVerficationCreateError, ThrowOnError>({
            ...options,
            url: '/api/sso-verfication/'
        });
    }
    
    public static submitFeedbackCreate<ThrowOnError extends boolean = true>(options: Options<SubmitFeedbackCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<SubmitFeedbackCreateResponse, SubmitFeedbackCreateError, ThrowOnError>({
            ...options,
            url: '/api/submit-feedback/'
        });
    }
    
    public static suggestedMediaCreate<ThrowOnError extends boolean = true>(options: Options<SuggestedMediaCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<SuggestedMediaCreateResponse, SuggestedMediaCreateError, ThrowOnError>({
            ...options,
            url: '/api/suggested-media/'
        });
    }
    
    /**
     * Returns the list of languages supported by Lumen5.
     */
    public static supportedLanguagesList<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<SupportedLanguagesListResponse, SupportedLanguagesListError, ThrowOnError>({
            ...options,
            url: '/api/supported-languages/'
        });
    }
    
    public static taskResultRetrieve<ThrowOnError extends boolean = true>(options: Options<TaskResultRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<TaskResultRetrieveResponse, TaskResultRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/task-result/{task_id}/'
        });
    }
    
    /**
     * Revokes a task and marks the corresponding partial_result as revoked
     * Required params:
     * - task_id: the ID of the task to delete the partial result for
     */
    public static taskResultDestroy<ThrowOnError extends boolean = true>(options: Options<TaskResultDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<TaskResultDestroyResponse, TaskResultDestroyError, ThrowOnError>({
            ...options,
            url: '/api/task-result/{task_id}/'
        });
    }
    
    public static taskResultsList<ThrowOnError extends boolean = true>(options: Options<TaskResultsListData, ThrowOnError>) {
        return (options?.client ?? client).get<TaskResultsListResponse, TaskResultsListError, ThrowOnError>({
            ...options,
            url: '/api/task-results/'
        });
    }
    
    public static teamInvitationsList<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<TeamInvitationsListResponse, TeamInvitationsListError, ThrowOnError>({
            ...options,
            url: '/api/team-invitations/'
        });
    }
    
    public static teamInvitationsCreate<ThrowOnError extends boolean = true>(options: Options<TeamInvitationsCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<TeamInvitationsCreateResponse, TeamInvitationsCreateError, ThrowOnError>({
            ...options,
            url: '/api/team-invitations/'
        });
    }
    
    public static teamInvitationsRetrieve<ThrowOnError extends boolean = true>(options: Options<TeamInvitationsRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<TeamInvitationsRetrieveResponse, TeamInvitationsRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/team-invitations/{id}/'
        });
    }
    
    public static teamInvitationsDestroy<ThrowOnError extends boolean = true>(options: Options<TeamInvitationsDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<TeamInvitationsDestroyResponse, TeamInvitationsDestroyError, ThrowOnError>({
            ...options,
            url: '/api/team-invitations/{id}/'
        });
    }
    
    public static teamInvitationsResendCreate<ThrowOnError extends boolean = true>(options: Options<TeamInvitationsResendCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<TeamInvitationsResendCreateResponse, TeamInvitationsResendCreateError, ThrowOnError>({
            ...options,
            url: '/api/team-invitations/{id}/resend/'
        });
    }
    
    public static teamMembersList<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<TeamMembersListResponse, TeamMembersListError, ThrowOnError>({
            ...options,
            url: '/api/team-members/'
        });
    }
    
    public static teamMembersUpdate<ThrowOnError extends boolean = true>(options: Options<TeamMembersUpdateData, ThrowOnError>) {
        return (options?.client ?? client).put<TeamMembersUpdateResponse, TeamMembersUpdateError, ThrowOnError>({
            ...options,
            url: '/api/team-members/{id}/'
        });
    }
    
    public static teamMembersPartialUpdate<ThrowOnError extends boolean = true>(options: Options<TeamMembersPartialUpdateData, ThrowOnError>) {
        return (options?.client ?? client).patch<TeamMembersPartialUpdateResponse, TeamMembersPartialUpdateError, ThrowOnError>({
            ...options,
            url: '/api/team-members/{id}/'
        });
    }
    
    public static teamMembersDestroy<ThrowOnError extends boolean = true>(options: Options<TeamMembersDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<TeamMembersDestroyResponse, TeamMembersDestroyError, ThrowOnError>({
            ...options,
            url: '/api/team-members/{id}/'
        });
    }
    
    public static teamMembersDeleteUserAccountDestroy<ThrowOnError extends boolean = true>(options: Options<TeamMembersDeleteUserAccountDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<TeamMembersDeleteUserAccountDestroyResponse, TeamMembersDeleteUserAccountDestroyError, ThrowOnError>({
            ...options,
            url: '/api/team-members/{id}/delete_user_account/'
        });
    }
    
    public static teamMembersTwoFactorAuthenticationRetrieve<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<TeamMembersTwoFactorAuthenticationRetrieveResponse, TeamMembersTwoFactorAuthenticationRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/team-members/two_factor_authentication/'
        });
    }
    
    public static teamMembersTwoFactorAuthenticationCreate<ThrowOnError extends boolean = true>(options: Options<TeamMembersTwoFactorAuthenticationCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<TeamMembersTwoFactorAuthenticationCreateResponse, TeamMembersTwoFactorAuthenticationCreateError, ThrowOnError>({
            ...options,
            url: '/api/team-members/two_factor_authentication/'
        });
    }
    
    /**
     * Get the Team details and capabilities
     */
    public static teamSettingsRetrieve<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<TeamSettingsRetrieveResponse, TeamSettingsRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/team-settings/'
        });
    }
    
    public static teamSettingsPartialUpdate<ThrowOnError extends boolean = true>(options?: Options<TeamSettingsPartialUpdateData, ThrowOnError>) {
        return (options?.client ?? client).patch<TeamSettingsPartialUpdateResponse, TeamSettingsPartialUpdateError, ThrowOnError>({
            ...options,
            url: '/api/team-settings/'
        });
    }
    
    /**
     * API endpoint that allows template categories to be viewed or deleted
     */
    public static templateCategoriesList<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<TemplateCategoriesListResponse, TemplateCategoriesListError, ThrowOnError>({
            ...options,
            url: '/api/template-categories/'
        });
    }
    
    /**
     * API endpoint that returns template information including IDs, aspect ratios, and descriptions.
     * Returns the same data structure as get_template_options with custom_templates, public_templates, and template_ids.
     */
    public static templateInfoList<ThrowOnError extends boolean = true>(options?: Options<TemplateInfoListData, ThrowOnError>) {
        return (options?.client ?? client).get<TemplateInfoListResponse, TemplateInfoListError, ThrowOnError>({
            ...options,
            url: '/api/template-info/'
        });
    }
    
    /**
     * API endpoint that allows templates to be viewed or edited.
     */
    public static templatesList<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<TemplatesListResponse, TemplatesListError, ThrowOnError>({
            ...options,
            url: '/api/templates/'
        });
    }
    
    /**
     * API endpoint that allows templates to be viewed or edited.
     */
    public static templatesCreate<ThrowOnError extends boolean = true>(options: Options<TemplatesCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<TemplatesCreateResponse, TemplatesCreateError, ThrowOnError>({
            ...options,
            url: '/api/templates/'
        });
    }
    
    /**
     * API endpoint that allows templates to be viewed or edited.
     */
    public static templatesRetrieve<ThrowOnError extends boolean = true>(options: Options<TemplatesRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<TemplatesRetrieveResponse, TemplatesRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/templates/{id}/'
        });
    }
    
    /**
     * API endpoint that allows templates to be viewed or edited.
     */
    public static templatesUpdate<ThrowOnError extends boolean = true>(options: Options<TemplatesUpdateData, ThrowOnError>) {
        return (options?.client ?? client).put<TemplatesUpdateResponse, TemplatesUpdateError, ThrowOnError>({
            ...options,
            url: '/api/templates/{id}/'
        });
    }
    
    /**
     * API endpoint that allows templates to be viewed or edited.
     */
    public static templatesPartialUpdate<ThrowOnError extends boolean = true>(options: Options<TemplatesPartialUpdateData, ThrowOnError>) {
        return (options?.client ?? client).patch<TemplatesPartialUpdateResponse, TemplatesPartialUpdateError, ThrowOnError>({
            ...options,
            url: '/api/templates/{id}/'
        });
    }
    
    /**
     * API endpoint that allows templates to be viewed or edited.
     */
    public static templatesDestroy<ThrowOnError extends boolean = true>(options: Options<TemplatesDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<TemplatesDestroyResponse, TemplatesDestroyError, ThrowOnError>({
            ...options,
            url: '/api/templates/{id}/'
        });
    }
    
    /**
     * Enable this global template on every requested template in one call, so a new
     * design set can be rolled out without saving each template individually. Templates
     * that already have it are skipped; the response lists the ones that were newly
     * enabled.
     */
    public static templatesEnableForTemplatesCreate<ThrowOnError extends boolean = true>(options: Options<TemplatesEnableForTemplatesCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<TemplatesEnableForTemplatesCreateResponse, TemplatesEnableForTemplatesCreateError, ThrowOnError>({
            ...options,
            url: '/api/templates/{id}/enable_for_templates/'
        });
    }
    
    /**
     * API endpoint that allows display groups to be created, edited or listed
     */
    public static templatesDisplayGroupsList<ThrowOnError extends boolean = true>(options: Options<TemplatesDisplayGroupsListData, ThrowOnError>) {
        return (options?.client ?? client).get<TemplatesDisplayGroupsListResponse, TemplatesDisplayGroupsListError, ThrowOnError>({
            ...options,
            url: '/api/templates/{template_pk}/display-groups/'
        });
    }
    
    /**
     * API endpoint that allows display groups to be created, edited or listed
     */
    public static templatesDisplayGroupsCreate<ThrowOnError extends boolean = true>(options: Options<TemplatesDisplayGroupsCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<TemplatesDisplayGroupsCreateResponse, TemplatesDisplayGroupsCreateError, ThrowOnError>({
            ...options,
            url: '/api/templates/{template_pk}/display-groups/'
        });
    }
    
    /**
     * API endpoint that allows display groups to be created, edited or listed
     */
    public static templatesDisplayGroupsRetrieve<ThrowOnError extends boolean = true>(options: Options<TemplatesDisplayGroupsRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<TemplatesDisplayGroupsRetrieveResponse, TemplatesDisplayGroupsRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/templates/{template_pk}/display-groups/{id}/'
        });
    }
    
    /**
     * API endpoint that allows display groups to be created, edited or listed
     */
    public static templatesDisplayGroupsPartialUpdate<ThrowOnError extends boolean = true>(options: Options<TemplatesDisplayGroupsPartialUpdateData, ThrowOnError>) {
        return (options?.client ?? client).patch<TemplatesDisplayGroupsPartialUpdateResponse, TemplatesDisplayGroupsPartialUpdateError, ThrowOnError>({
            ...options,
            url: '/api/templates/{template_pk}/display-groups/{id}/'
        });
    }
    
    /**
     * API endpoint that allows display groups to be created, edited or listed
     */
    public static templatesDisplayGroupsOrderPartialUpdate<ThrowOnError extends boolean = true>(options: Options<TemplatesDisplayGroupsOrderPartialUpdateData, ThrowOnError>) {
        return (options?.client ?? client).patch<TemplatesDisplayGroupsOrderPartialUpdateResponse, TemplatesDisplayGroupsOrderPartialUpdateError, ThrowOnError>({
            ...options,
            url: '/api/templates/{template_pk}/display-groups/order/'
        });
    }
    
    /**
     * List templates that support the audiogram (waveform) style — i.e. that have a
     * non-default, active, voiceover scene design containing a waveform icon. Used so the
     * agent can suggest a template to switch to when the current one has no waveform design.
     *
     * Mirrors what the consumer (find_waveform_scene_design) actually probes: it only ever
     * instantiates active voiceover scene designs, so scanning any other design would suggest
     * a template that hits the same dead end after switching. The 'waveform' substring in the
     * scene design JSON is a proxy for the waveform icon (whose voice-reactive playback mode
     * only materializes once Luminary instantiates the design); the agent re-confirms with
     * find_waveform_scene_design after switching.
     */
    public static templatesWaveformCapableRetrieve<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<TemplatesWaveformCapableRetrieveResponse, TemplatesWaveformCapableRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/templates/waveform_capable/'
        });
    }
    
    public static textToVoiceoverAssetCreate<ThrowOnError extends boolean = true>(options: Options<TextToVoiceoverAssetCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<TextToVoiceoverAssetCreateResponse, TextToVoiceoverAssetCreateError, ThrowOnError>({
            ...options,
            url: '/api/text-to-voiceover-asset/'
        });
    }
    
    public static textTranslateCreate<ThrowOnError extends boolean = true>(options: Options<TextTranslateCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<TextTranslateCreateResponse, TextTranslateCreateError, ThrowOnError>({
            ...options,
            url: '/api/text-translate/'
        });
    }
    
    /**
     * Price token usage in dollars.
     */
    public static tokensCostCreate<ThrowOnError extends boolean = true>(options: Options<TokensCostCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<TokensCostCreateResponse, TokensCostCreateError, ThrowOnError>({
            ...options,
            url: '/api/tokens/cost/'
        });
    }
    
    public static topUploadsTagsRetrieve<ThrowOnError extends boolean = true>(options: Options<TopUploadsTagsRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<TopUploadsTagsRetrieveResponse, TopUploadsTagsRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/top-uploads-tags/'
        });
    }
    
    /**
     * Queues a transcription task for a file at the given GCS URL. The URL must point at
     * one of the caller's own uploads in the transient upload bucket (`temporarythirty`),
     * obtained by calling `/api/upload-urls/` with `temporary: true` and uploading via the
     * returned signed URL. The result is published to the user's WebSocket task channel.
     */
    public static transcribeUrlCreate<ThrowOnError extends boolean = true>(options: Options<TranscribeUrlCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<TranscribeUrlCreateResponse, TranscribeUrlCreateError, ThrowOnError>({
            ...options,
            url: '/api/transcribe-url/'
        });
    }
    
    /**
     * This endpoint generates the clip given the transcript, clip plan, and language code.
     */
    public static transcriptClipCreate<ThrowOnError extends boolean = true>(options: Options<TranscriptClipCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<TranscriptClipCreateResponse, TranscriptClipCreateError, ThrowOnError>({
            ...options,
            url: '/api/transcript-clip/'
        });
    }
    
    /**
     * Mints a single-use ElevenLabs Scribe Realtime token (15-minute expiry) so the
     * browser can open a WebSocket directly to ElevenLabs without ever seeing our
     * long-lived API key.
     *
     * The endpoint is intentionally minimal — see ElevenLabs docs:
     * POST https://api.elevenlabs.io/v1/single-use-token/realtime_scribe
     */
    public static transcriptionTokenCreate<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).post<TranscriptionTokenCreateResponse, TranscriptionTokenCreateError, ThrowOnError>({
            ...options,
            url: '/api/transcription-token/'
        });
    }
    
    public static transitionedAssetErrorCreate<ThrowOnError extends boolean = true>(options: Options<TransitionedAssetErrorCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<TransitionedAssetErrorCreateResponse, TransitionedAssetErrorCreateError, ThrowOnError>({
            ...options,
            url: '/api/transitioned-asset-error/'
        });
    }
    
    /**
     * Duplicate a video and translate it entirely on the backend.
     *
     * Returns the duplicated video object (PROCESSING status) and task_id so the
     * frontend can track progress via WebSocket.
     */
    public static translateVideoBackendCreate<ThrowOnError extends boolean = true>(options: Options<TranslateVideoBackendCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<TranslateVideoBackendCreateResponse, TranslateVideoBackendCreateError, ThrowOnError>({
            ...options,
            url: '/api/translate-video-backend/'
        });
    }
    
    /**
     * Creates a new video from an existing video but with a different template.
     */
    public static transmogVideoCreate<ThrowOnError extends boolean = true>(options: Options<TransmogVideoCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<TransmogVideoCreateResponse, TransmogVideoCreateError, ThrowOnError>({
            ...options,
            url: '/api/transmog-video/'
        });
    }
    
    public static trustCenterPrivateDocumentsRetrieve<ThrowOnError extends boolean = true>(options: Options<TrustCenterPrivateDocumentsRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<TrustCenterPrivateDocumentsRetrieveResponse, TrustCenterPrivateDocumentsRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/trust-center/private-documents/{doc_key}/'
        });
    }
    
    /**
     * Receives results from the upload-diagnostic page and posts them to the #security
     * Slack channel. Requires auth so the reporter's identity comes from the trusted
     * session (not attacker-controlled input) and the endpoint isn't publicly exposed.
     */
    public static uploadDiagnosticsCreate<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).post<UploadDiagnosticsCreateResponse, UploadDiagnosticsCreateError, ThrowOnError>({
            ...options,
            url: '/api/upload-diagnostics/'
        });
    }
    
    /**
     * Creates a resumable upload session to the user's gcs bucket.
     */
    public static uploadUrlsCreate<ThrowOnError extends boolean = true>(options: Options<UploadUrlsCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<UploadUrlsCreateResponse, UploadUrlsCreateError, ThrowOnError>({
            ...options,
            url: '/api/upload-urls/'
        });
    }
    
    /**
     * The endpoint for updating media asset metadata.
     */
    public static uploadsMetadataUpdateUpdate<ThrowOnError extends boolean = true>(options: Options<UploadsMetadataUpdateUpdateData, ThrowOnError>) {
        return (options?.client ?? client).put<UploadsMetadataUpdateUpdateResponse, UploadsMetadataUpdateUpdateError, ThrowOnError>({
            ...options,
            url: '/api/uploads-metadata-update/'
        });
    }
    
    /**
     * Get a team's usage limit
     */
    public static usageLimitsRetrieve<ThrowOnError extends boolean = true>(options?: Options<UsageLimitsRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<UsageLimitsRetrieveResponse, UsageLimitsRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/usage_limits/'
        });
    }
    
    /**
     * Returns ordered list of templates used in the workspace
     */
    public static usedTemplatesRetrieve<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<UsedTemplatesRetrieveResponse, UsedTemplatesRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/used-templates/'
        });
    }
    
    /**
     * Retrieve the current user's profile without requiring an ID field.
     */
    public static userRetrieve<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<UserRetrieveResponse, UserRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/user/'
        });
    }
    
    /**
     * Adds a value to the user.extra_data json field
     */
    public static userExtraDataCreate<ThrowOnError extends boolean = true>(options: Options<UserExtraDataCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<UserExtraDataCreateResponse, UserExtraDataCreateError, ThrowOnError>({
            ...options,
            url: '/api/user/extra_data/'
        });
    }
    
    /**
     * Clears a category from the user.extra_data json field
     */
    public static userExtraDataClearCreate<ThrowOnError extends boolean = true>(options: Options<UserExtraDataClearCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<UserExtraDataClearCreateResponse, UserExtraDataClearCreateError, ThrowOnError>({
            ...options,
            url: '/api/user/extra_data/clear/'
        });
    }
    
    /**
     * It's possible for users to be in a workspace but not have access to any projects. This's fine for Admin but not for all other
     * user roles, their videos have to be part of a project.
     * This endpoint returns a boolean value indicating if this case is true for the user.
     */
    public static userHasValidProjectInWorkspaceRetrieve<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<UserHasValidProjectInWorkspaceRetrieveResponse, UserHasValidProjectInWorkspaceRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/user/has-valid-project-in-workspace/'
        });
    }
    
    /**
     * Notification settings for a user. Available through an unauthed-page (unsub) so secured
     * via user_id and email_secret_uuid.
     */
    public static userNotificationsRetrieve<ThrowOnError extends boolean = true>(options: Options<UserNotificationsRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<UserNotificationsRetrieveResponse, UserNotificationsRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/user/notifications/{user_id}/{email_secret_uuid}/'
        });
    }
    
    /**
     * Notification settings for a user. Available through an unauthed-page (unsub) so secured
     * via user_id and email_secret_uuid.
     */
    public static userNotificationsPartialUpdate<ThrowOnError extends boolean = true>(options: Options<UserNotificationsPartialUpdateData, ThrowOnError>) {
        return (options?.client ?? client).patch<UserNotificationsPartialUpdateResponse, UserNotificationsPartialUpdateError, ThrowOnError>({
            ...options,
            url: '/api/user/notifications/{user_id}/{email_secret_uuid}/'
        });
    }
    
    /**
     * Manages the signed-in user's own API keys.
     *
     * Session only, so a leaked key cannot mint or enumerate keys. Viewers may hold keys too:
     * a key never grants more than its user's role allows.
     */
    public static v1ApiKeysList<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<V1ApiKeysListResponse, V1ApiKeysListError, ThrowOnError>({
            ...options,
            url: '/api/v1/api-keys/'
        });
    }
    
    /**
     * Manages the signed-in user's own API keys.
     *
     * Session only, so a leaked key cannot mint or enumerate keys. Viewers may hold keys too:
     * a key never grants more than its user's role allows.
     */
    public static v1ApiKeysCreate<ThrowOnError extends boolean = true>(options: Options<V1ApiKeysCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<V1ApiKeysCreateResponse, V1ApiKeysCreateError, ThrowOnError>({
            ...options,
            url: '/api/v1/api-keys/'
        });
    }
    
    /**
     * Manages the signed-in user's own API keys.
     *
     * Session only, so a leaked key cannot mint or enumerate keys. Viewers may hold keys too:
     * a key never grants more than its user's role allows.
     */
    public static v1ApiKeysDestroy<ThrowOnError extends boolean = true>(options: Options<V1ApiKeysDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<V1ApiKeysDestroyResponse, V1ApiKeysDestroyError, ThrowOnError>({
            ...options,
            url: '/api/v1/api-keys/{id}/'
        });
    }
    
    /**
     * The workspace's blueprints.
     */
    public static v1VideoCreationBlueprintsList<ThrowOnError extends boolean = true>(options: Options<V1VideoCreationBlueprintsListData, ThrowOnError>) {
        return (options?.client ?? client).get<V1VideoCreationBlueprintsListResponse, V1VideoCreationBlueprintsListError, ThrowOnError>({
            ...options,
            url: '/api/v1/video-creation/blueprints/'
        });
    }
    
    /**
     * The workspace's brand kits.
     */
    public static v1VideoCreationBrandKitsList<ThrowOnError extends boolean = true>(options: Options<V1VideoCreationBrandKitsListData, ThrowOnError>) {
        return (options?.client ?? client).get<V1VideoCreationBrandKitsListResponse, V1VideoCreationBrandKitsListError, ThrowOnError>({
            ...options,
            url: '/api/v1/video-creation/brand-kits/'
        });
    }
    
    /**
     * The kinds of video a request can ask for.
     */
    public static v1VideoCreationRecipesList<ThrowOnError extends boolean = true>(options: Options<V1VideoCreationRecipesListData, ThrowOnError>) {
        return (options?.client ?? client).get<V1VideoCreationRecipesListResponse, V1VideoCreationRecipesListError, ThrowOnError>({
            ...options,
            url: '/api/v1/video-creation/recipes/'
        });
    }
    
    public static v1VideoCreationRequestsList<ThrowOnError extends boolean = true>(options: Options<V1VideoCreationRequestsListData, ThrowOnError>) {
        return (options?.client ?? client).get<V1VideoCreationRequestsListResponse, V1VideoCreationRequestsListError, ThrowOnError>({
            ...options,
            url: '/api/v1/video-creation/requests/'
        });
    }
    
    public static v1VideoCreationRequestsCreate<ThrowOnError extends boolean = true>(options: Options<V1VideoCreationRequestsCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<V1VideoCreationRequestsCreateResponse, V1VideoCreationRequestsCreateError, ThrowOnError>({
            ...options,
            url: '/api/v1/video-creation/requests/'
        });
    }
    
    public static v1VideoCreationRequestsRetrieve<ThrowOnError extends boolean = true>(options: Options<V1VideoCreationRequestsRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<V1VideoCreationRequestsRetrieveResponse, V1VideoCreationRequestsRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/v1/video-creation/requests/{request_id}/'
        });
    }
    
    /**
     * Validates a request body and shows what it would store, without creating anything.
     */
    public static v1VideoCreationResolveCreate<ThrowOnError extends boolean = true>(options: Options<V1VideoCreationResolveCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<V1VideoCreationResolveCreateResponse, V1VideoCreationResolveCreateError, ThrowOnError>({
            ...options,
            url: '/api/v1/video-creation/resolve/'
        });
    }
    
    /**
     * Templates the workspace can use.
     */
    public static v1VideoCreationTemplatesList<ThrowOnError extends boolean = true>(options: Options<V1VideoCreationTemplatesListData, ThrowOnError>) {
        return (options?.client ?? client).get<V1VideoCreationTemplatesListResponse, V1VideoCreationTemplatesListError, ThrowOnError>({
            ...options,
            url: '/api/v1/video-creation/templates/'
        });
    }
    
    /**
     * AI voices the workspace can use.
     */
    public static v1VideoCreationVoicesList<ThrowOnError extends boolean = true>(options: Options<V1VideoCreationVoicesListData, ThrowOnError>) {
        return (options?.client ?? client).get<V1VideoCreationVoicesListResponse, V1VideoCreationVoicesListError, ThrowOnError>({
            ...options,
            url: '/api/v1/video-creation/voices/'
        });
    }
    
    public static v1VideoCreationWebhookEndpointsList<ThrowOnError extends boolean = true>(options?: Options<V1VideoCreationWebhookEndpointsListData, ThrowOnError>) {
        return (options?.client ?? client).get<V1VideoCreationWebhookEndpointsListResponse, V1VideoCreationWebhookEndpointsListError, ThrowOnError>({
            ...options,
            url: '/api/v1/video-creation/webhook-endpoints/'
        });
    }
    
    public static v1VideoCreationWebhookEndpointsCreate<ThrowOnError extends boolean = true>(options: Options<V1VideoCreationWebhookEndpointsCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<V1VideoCreationWebhookEndpointsCreateResponse, V1VideoCreationWebhookEndpointsCreateError, ThrowOnError>({
            ...options,
            url: '/api/v1/video-creation/webhook-endpoints/'
        });
    }
    
    public static v1VideoCreationWebhookEndpointsDestroy<ThrowOnError extends boolean = true>(options: Options<V1VideoCreationWebhookEndpointsDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<V1VideoCreationWebhookEndpointsDestroyResponse, V1VideoCreationWebhookEndpointsDestroyError, ThrowOnError>({
            ...options,
            url: '/api/v1/video-creation/webhook-endpoints/{endpoint_id}/'
        });
    }
    
    /**
     * Issues a new signing secret. The old one keeps signing deliveries for a day, so nothing drops.
     */
    public static v1VideoCreationWebhookEndpointsRotateSecretCreate<ThrowOnError extends boolean = true>(options: Options<V1VideoCreationWebhookEndpointsRotateSecretCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<V1VideoCreationWebhookEndpointsRotateSecretCreateResponse, V1VideoCreationWebhookEndpointsRotateSecretCreateError, ThrowOnError>({
            ...options,
            url: '/api/v1/video-creation/webhook-endpoints/{endpoint_id}/rotate-secret/'
        });
    }
    
    /**
     * The workspaces the caller can create videos in.
     */
    public static v1VideoCreationWorkspacesList<ThrowOnError extends boolean = true>(options?: Options<V1VideoCreationWorkspacesListData, ThrowOnError>) {
        return (options?.client ?? client).get<V1VideoCreationWorkspacesListResponse, V1VideoCreationWorkspacesListError, ThrowOnError>({
            ...options,
            url: '/api/v1/video-creation/workspaces/'
        });
    }
    
    /**
     * Validate the dataset video
     */
    public static validateDatasetVideoRetrieve<ThrowOnError extends boolean = true>(options: Options<ValidateDatasetVideoRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<ValidateDatasetVideoRetrieveResponse, ValidateDatasetVideoRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/validate-dataset-video/{video_id}/'
        });
    }
    
    /**
     * Retrieves a list of videos given a set of filters and sort
     *
     * This is done in 2 stages:
     * - Stage 1: Fetch only video ids of filtered and sorted videos
     * - Stage 2: Fetch all data for the video ids
     */
    public static videoList<ThrowOnError extends boolean = true>(options?: Options<VideoListData, ThrowOnError>) {
        return (options?.client ?? client).get<VideoListResponse, VideoListError, ThrowOnError>({
            ...options,
            url: '/api/video/'
        });
    }
    
    /**
     * Create a video from scratch
     */
    public static videoCreate<ThrowOnError extends boolean = true>(options: Options<VideoCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<VideoCreateResponse, VideoCreateError, ThrowOnError>({
            ...options,
            url: '/api/video/'
        });
    }
    
    public static videoApprovalStatusRetrieve<ThrowOnError extends boolean = true>(options: Options<VideoApprovalStatusRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<VideoApprovalStatusRetrieveResponse, VideoApprovalStatusRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/video-approval-status/{video_id}/'
        });
    }
    
    public static videoApprovalStatusUpdate<ThrowOnError extends boolean = true>(options: Options<VideoApprovalStatusUpdateData, ThrowOnError>) {
        return (options?.client ?? client).put<VideoApprovalStatusUpdateResponse, VideoApprovalStatusUpdateError, ThrowOnError>({
            ...options,
            url: '/api/video-approval-status/{video_id}/'
        });
    }
    
    public static videoApprovalStatusPartialUpdate<ThrowOnError extends boolean = true>(options: Options<VideoApprovalStatusPartialUpdateData, ThrowOnError>) {
        return (options?.client ?? client).patch<VideoApprovalStatusPartialUpdateResponse, VideoApprovalStatusPartialUpdateError, ThrowOnError>({
            ...options,
            url: '/api/video-approval-status/{video_id}/'
        });
    }
    
    /**
     * Endpoint used to interact with VideoComments. This is used for
     * creating new comments, fetching a list of comments and
     * deleting existing comments.
     */
    public static videoCommentList<ThrowOnError extends boolean = true>(options: Options<VideoCommentListData, ThrowOnError>) {
        return (options?.client ?? client).get<VideoCommentListResponse, VideoCommentListError, ThrowOnError>({
            ...options,
            url: '/api/video-comment/'
        });
    }
    
    /**
     * Creates a new video comment.
     *
     * Required params:
     *
     * - video_id: id of the video that the comment will be attached to
     * - message: json object containing the message for the video.
     */
    public static videoCommentCreate<ThrowOnError extends boolean = true>(options: Options<VideoCommentCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<VideoCommentCreateResponse, VideoCommentCreateError, ThrowOnError>({
            ...options,
            url: '/api/video-comment/'
        });
    }
    
    /**
     * Deletes a video comment.
     *
     * Required params:
     *
     * - comment_id: id of the comment that should be deleted
     */
    public static videoCommentDestroy<ThrowOnError extends boolean = true>(options: Options<VideoCommentDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<VideoCommentDestroyResponse, VideoCommentDestroyError, ThrowOnError>({
            ...options,
            url: '/api/video-comment/{id}/'
        });
    }
    
    /**
     * The runner page reports how its run ended, from the browser session the run logged in.
     */
    public static videoCreationRunOutcomeCreate<ThrowOnError extends boolean = true>(options: Options<VideoCreationRunOutcomeCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<VideoCreationRunOutcomeCreateResponse, VideoCreationRunOutcomeCreateError, ThrowOnError>({
            ...options,
            url: '/api/video-creation-runs/{run_id}/outcome/'
        });
    }
    
    public static videoGenerationCreate<ThrowOnError extends boolean = true>(options: Options<VideoGenerationCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<VideoGenerationCreateResponse, VideoGenerationCreateError, ThrowOnError>({
            ...options,
            url: '/api/video-generation/'
        });
    }
    
    /**
     * Triggers the task to validate a video poster image
     * Params:
     *
     * - bucket: the name of the bucket used
     * - file_name: the filename to validate inside of the bucket
     * - video_id: the id of the video to use the asset as a poster url for
     */
    public static videoPosterValidationUpdate<ThrowOnError extends boolean = true>(options: Options<VideoPosterValidationUpdateData, ThrowOnError>) {
        return (options?.client ?? client).put<VideoPosterValidationUpdateResponse, VideoPosterValidationUpdateError, ThrowOnError>({
            ...options,
            url: '/api/video-poster-validation/'
        });
    }
    
    public static videoRetrieve<ThrowOnError extends boolean = true>(options: Options<VideoRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<VideoRetrieveResponse, VideoRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/video/{video_id}/'
        });
    }
    
    /**
     * SAVE EXISTING VIDEO
     * Save video data to the database.
     */
    public static videoUpdate<ThrowOnError extends boolean = true>(options: Options<VideoUpdateData, ThrowOnError>) {
        return (options?.client ?? client).put<VideoUpdateResponse, VideoUpdateError, ThrowOnError>({
            ...options,
            url: '/api/video/{video_id}/'
        });
    }
    
    /**
     * Updates a field of the video. Currently only the name and visibility fields are supported.
     */
    public static videoPartialUpdate<ThrowOnError extends boolean = true>(options: Options<VideoPartialUpdateData, ThrowOnError>) {
        return (options?.client ?? client).patch<VideoPartialUpdateResponse, VideoPartialUpdateError, ThrowOnError>({
            ...options,
            url: '/api/video/{video_id}/'
        });
    }
    
    /**
     * Calls the groundhog analysis of scripts, detecting the "groundedness" of script
     * sentences to detect potential hallucinations.
     */
    public static videoGroundhogAnalysisCreate<ThrowOnError extends boolean = true>(options: Options<VideoGroundhogAnalysisCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<VideoGroundhogAnalysisCreateResponse, VideoGroundhogAnalysisCreateError, ThrowOnError>({
            ...options,
            url: '/api/video/{video_id}/groundhog-analysis/'
        });
    }
    
    /**
     * Gets a URL to download a video, if a video has multiple files (VideoRenders), then this
     * returns a task id, which once complete will provide a URL to a zip file containing all videos.
     */
    public static videoShareDownloadRetrieve<ThrowOnError extends boolean = true>(options: Options<VideoShareDownloadRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<VideoShareDownloadRetrieveResponse, VideoShareDownloadRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/video/{video_id}/share/download/'
        });
    }
    
    /**
     * Mark video as downloaded
     */
    public static videoShareDownloadCreate<ThrowOnError extends boolean = true>(options: Options<VideoShareDownloadCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<VideoShareDownloadCreateResponse, VideoShareDownloadCreateError, ThrowOnError>({
            ...options,
            url: '/api/video/{video_id}/share/download/'
        });
    }
    
    public static videoTranslateV2Create<ThrowOnError extends boolean = true>(options: Options<VideoTranslateV2CreateData, ThrowOnError>) {
        return (options?.client ?? client).post<VideoTranslateV2CreateResponse, VideoTranslateV2CreateError, ThrowOnError>({
            ...options,
            url: '/api/video/{video_id}/translate-v2/'
        });
    }
    
    /**
     * Load the translated text of a video. This endpoint is made public on purpose which is being called
     * on the video share page.
     */
    public static videoTranslatedTextList<ThrowOnError extends boolean = true>(options: Options<VideoTranslatedTextListData, ThrowOnError>) {
        return (options?.client ?? client).get<VideoTranslatedTextListResponse, VideoTranslatedTextListError, ThrowOnError>({
            ...options,
            url: '/api/video/{video_id}/translated_text/'
        });
    }
    
    /**
     * Restore a video version by creating a new video with the old state.
     */
    public static videosRestoreCreate<ThrowOnError extends boolean = true>(options: Options<VideosRestoreCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<VideosRestoreCreateResponse, VideosRestoreCreateError, ThrowOnError>({
            ...options,
            url: '/api/videos/{video_id}/restore/'
        });
    }
    
    /**
     * List available version history for a video from GCS.
     */
    public static videosVersionsRetrieve<ThrowOnError extends boolean = true>(options: Options<VideosVersionsRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<VideosVersionsRetrieveResponse, VideosVersionsRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/videos/{video_id}/versions/'
        });
    }
    
    /**
     * Get the video_data for a specific version (for preview).
     */
    public static videosVersionDataRetrieve<ThrowOnError extends boolean = true>(options: Options<VideosVersionDataRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<VideosVersionDataRetrieveResponse, VideosVersionDataRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/videos/{video_id}/versions/{generation}/'
        });
    }
    
    /**
     * Manipulate the archived status of multiple videos in a workspace or project.
     */
    public static videosArchiveMultipleVideosUpdate<ThrowOnError extends boolean = true>(options: Options<VideosArchiveMultipleVideosUpdateData, ThrowOnError>) {
        return (options?.client ?? client).put<VideosArchiveMultipleVideosUpdateResponse, VideosArchiveMultipleVideosUpdateError, ThrowOnError>({
            ...options,
            url: '/api/videos/archive-multiple-videos/'
        });
    }
    
    /**
     * Bulk publish multiple videos by queuing them for render.
     */
    public static videosBulkPublishCreate<ThrowOnError extends boolean = true>(options: Options<VideosBulkPublishCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<VideosBulkPublishCreateResponse, VideosBulkPublishCreateError, ThrowOnError>({
            ...options,
            url: '/api/videos/bulk-publish/'
        });
    }
    
    /**
     * This endpoint is used to create a video from a blueprint.
     *
     * Access is restricted to users with access to the blueprint's workspace.
     *
     * Returns the video object created.
     */
    public static videosCreateFromBlueprintCreate<ThrowOnError extends boolean = true>(options: Options<VideosCreateFromBlueprintCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<VideosCreateFromBlueprintCreateResponse, VideosCreateFromBlueprintCreateError, ThrowOnError>({
            ...options,
            url: '/api/videos/create-from-blueprint/'
        });
    }
    
    public static videosDuplicateVideosCreate<ThrowOnError extends boolean = true>(options: Options<VideosDuplicateVideosCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<VideosDuplicateVideosCreateResponse, VideosDuplicateVideosCreateError, ThrowOnError>({
            ...options,
            url: '/api/videos/duplicate_videos/'
        });
    }
    
    /**
     * Move multiple videos to a workpsace or project
     */
    public static videosMoveVideosPartialUpdate<ThrowOnError extends boolean = true>(options?: Options<VideosMoveVideosPartialUpdateData, ThrowOnError>) {
        return (options?.client ?? client).patch<VideosMoveVideosPartialUpdateResponse, VideosMoveVideosPartialUpdateError, ThrowOnError>({
            ...options,
            url: '/api/videos/move_videos/'
        });
    }
    
    /**
     * List scene sequences for a template, grouped by name with one video per aspect ratio.
     * Each group has `video_id`, `video_data`, and `video_data_hash` for each aspect
     * ratio the template supports. Groups missing any supported aspect ratio are dropped.
     * All authenticated users can access this endpoint.
     */
    public static videosSceneSequencesList<ThrowOnError extends boolean = true>(options: Options<VideosSceneSequencesListData, ThrowOnError>) {
        return (options?.client ?? client).get<VideosSceneSequencesListResponse, VideosSceneSequencesListError, ThrowOnError>({
            ...options,
            url: '/api/videos/scene-sequences/'
        });
    }
    
    public static workspaceList<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<WorkspaceListResponse, WorkspaceListError, ThrowOnError>({
            ...options,
            url: '/api/workspace/'
        });
    }
    
    public static workspaceCreate<ThrowOnError extends boolean = true>(options?: Options<WorkspaceCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<WorkspaceCreateResponse, WorkspaceCreateError, ThrowOnError>({
            ...options,
            url: '/api/workspace/'
        });
    }
    
    /**
     * Get all unique tags used by videos in workspace
     */
    public static workspaceVideoTagsRetrieve<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<WorkspaceVideoTagsRetrieveResponse, WorkspaceVideoTagsRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/workspace-video-tags/'
        });
    }
    
    public static workspaceRetrieve<ThrowOnError extends boolean = true>(options: Options<WorkspaceRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<WorkspaceRetrieveResponse, WorkspaceRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/workspace/{id}/'
        });
    }
    
    public static workspacePartialUpdate<ThrowOnError extends boolean = true>(options: Options<WorkspacePartialUpdateData, ThrowOnError>) {
        return (options?.client ?? client).patch<WorkspacePartialUpdateResponse, WorkspacePartialUpdateError, ThrowOnError>({
            ...options,
            url: '/api/workspace/{id}/'
        });
    }
    
    public static workspaceDestroy<ThrowOnError extends boolean = true>(options: Options<WorkspaceDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<WorkspaceDestroyResponse, WorkspaceDestroyError, ThrowOnError>({
            ...options,
            url: '/api/workspace/{id}/'
        });
    }
    
    public static workspaceAddMembersCreate<ThrowOnError extends boolean = true>(options: Options<WorkspaceAddMembersCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<WorkspaceAddMembersCreateResponse, WorkspaceAddMembersCreateError, ThrowOnError>({
            ...options,
            url: '/api/workspace/{id}/add_members/'
        });
    }
    
    public static workspaceAnalyticsRetrieve<ThrowOnError extends boolean = true>(options: Options<WorkspaceAnalyticsRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<WorkspaceAnalyticsRetrieveResponse, WorkspaceAnalyticsRetrieveError, ThrowOnError>({
            ...options,
            url: '/api/workspace/{id}/analytics/'
        });
    }
    
    public static workspaceRemoveMemberDestroy<ThrowOnError extends boolean = true>(options: Options<WorkspaceRemoveMemberDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<WorkspaceRemoveMemberDestroyResponse, WorkspaceRemoveMemberDestroyError, ThrowOnError>({
            ...options,
            url: '/api/workspace/{id}/remove_member/'
        });
    }
    
    public static youtubeChannelsList<ThrowOnError extends boolean = true>(options?: Options<unknown, ThrowOnError>) {
        return (options?.client ?? client).get<YoutubeChannelsListResponse, YoutubeChannelsListError, ThrowOnError>({
            ...options,
            url: '/api/youtube-channels/'
        });
    }
    
    public static youtubeChannelsCreate<ThrowOnError extends boolean = true>(options: Options<YoutubeChannelsCreateData, ThrowOnError>) {
        return (options?.client ?? client).post<YoutubeChannelsCreateResponse, YoutubeChannelsCreateError, ThrowOnError>({
            ...options,
            url: '/api/youtube-channels/'
        });
    }
    
    public static youtubeChannelsDestroy<ThrowOnError extends boolean = true>(options: Options<YoutubeChannelsDestroyData, ThrowOnError>) {
        return (options?.client ?? client).delete<YoutubeChannelsDestroyResponse, YoutubeChannelsDestroyError, ThrowOnError>({
            ...options,
            url: '/api/youtube-channels/{id}/'
        });
    }
    
    /**
     * A ViewSet for opening the file behind a chat document attachment, by id.
     */
    public static attachmentDocumentRetrieve<ThrowOnError extends boolean = true>(options: Options<AttachmentDocumentRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<AttachmentDocumentRetrieveResponse, AttachmentDocumentRetrieveError, ThrowOnError>({
            ...options,
            url: '/attachment/document/{id}/'
        });
    }
    
    /**
     * A ViewSet for opening the file behind a chat media attachment, by UUID.
     */
    public static attachmentMediaRetrieve<ThrowOnError extends boolean = true>(options: Options<AttachmentMediaRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<AttachmentMediaRetrieveResponse, AttachmentMediaRetrieveError, ThrowOnError>({
            ...options,
            url: '/attachment/media/{media_uuid}/'
        });
    }
    
    /**
     * Check a signup to see if it corresponds to an invitation to a team.
     */
    public static authInvitationRetrieve<ThrowOnError extends boolean = true>(options: Options<AuthInvitationRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<AuthInvitationRetrieveResponse, AuthInvitationRetrieveError, ThrowOnError>({
            ...options,
            url: '/auth/invitation/'
        });
    }
    
    /**
     * This endpoint is only available for internal requests (ie. localhost, 127.0.0.1, etc)
     * Get video_data for a video render.
     */
    public static renderVideoRenderDataRetrieve<ThrowOnError extends boolean = true>(options: Options<RenderVideoRenderDataRetrieveData, ThrowOnError>) {
        return (options?.client ?? client).get<RenderVideoRenderDataRetrieveResponse, RenderVideoRenderDataRetrieveError, ThrowOnError>({
            ...options,
            url: '/render/video-render-data/{video_render_id}/'
        });
    }
    
}